<template>

<div>

<!--<b-card>-->
    <b-row class="align-items-center justify-content-around">
        

        <b-row v-if="globalPage" class="align-items-center justify-content-center m-1" title="* will display the analytics for all videos. Possibility to select a specific video through its ID">
            <small>{{$ml.get('videos4all')}}</small>
            <b-input-group size="sm" :prepend="$ml.get('byid')" style="margin:0.5rem; font-color:#2F90B0">
                <b-form-input v-model="filter" @input=startTimeoutSearch></b-form-input>
            </b-input-group>
            {{$ml.get('or')}} 
            <b-button v-if="type==='platform'" variant="darkblue" style="margin-left:5px" size="sm" @click="getVideos();showModal('selectVideo')">{{$ml.get('selectvid')}}</b-button>
            <b-button v-if="type==='plugin'" variant="darkblue" style="margin-left:5px" size="sm" @click="getPluginVideosList();showModal('selectVideoPlugin')">{{$ml.get('selectvid')}}</b-button>
        </b-row>

        <b-row class="align-items-center justify-content-center m-1">
            <small>{{$ml.get('interval')}}</small>
            <b-form-select size="sm" v-model="intervalDisplayed" :options="intervalOptions" style="max-width:110px; margin:0.5rem" @change=loadData></b-form-select>
        </b-row>

        <b-row class="align-items-center justify-content-center m-1">
            <small>{{$ml.get('timerange')}}</small>

            <b-form-select size="sm" v-model="dateLabel" :options="dateLabelOptions" v-on:input="loadData()" style="max-width:150px; margin:0.5rem"></b-form-select>

            <date-picker size="sm" v-model="range" @input="calendarValidate = true" is-range is24hr mode="dateTime" :timezone="''" style="margin:0.5rem">
                <template size="sm" v-slot="{ inputEvents }">
                    <b-button size="sm" variant="quanteeclg" v-on="inputEvents.start">
                        <font-awesome-icon :icon="['fas', 'calendar-week']"></font-awesome-icon>&nbsp;
                        {{dateStart}} - {{dateEnd}}
                    </b-button>
                    &nbsp;
                    <b-button variant="quanteeclg" v-if="calendarValidate" size="sm" @click="timeRangeType=true, adjustDate(), loadData(), dateLabel='custom'" >
                        <font-awesome-icon style="color:green" :icon="['fas', 'check']"></font-awesome-icon>
                    </b-button>
                </template>
            </date-picker>
        </b-row>

        <b-row v-if="!isLoading" class="align-items-center justify-content-center m-1">
            <!--
            <b-button variant="msstreamblue" @click="downloadPDF" title="Export/print selected analytics as a PDF file">
                <font-awesome-icon :icon="['fas', 'file-export']"></font-awesome-icon>
                PDF 
            </b-button>
            -->
            <b-button size="sm" variant="darkblue" @click="downloadCSV" title="Export selected analytics as a CSV file"> 
                <font-awesome-icon :icon="['fas', 'file-export']"></font-awesome-icon>
                CSV 
            </b-button>
        </b-row>
    
        <b-row class="align-items-center justify-content-center m-1">
            <b-button size="sm" variant="mswarning" @click="loadData" title="Reload data with new parameters">
                <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon>
            </b-button>
        </b-row>

    </b-row>

    <b-row v-if="isLoading" class="justify-content-center marginal">
        <b-spinner label="Loading..."></b-spinner>
    </b-row>

    <b-row class="row1st">

        <div style="margin:5px">
            <b-button variant="quality" size="sm" title="High quality %" >
                <font-awesome-icon size="sm" icon="signal" />
            </b-button>
            &nbsp;<span style="font-weight:bold; color:#2F90B0">{{quality_computed}}</span> {{$ml.get('ofthetime')}}
        </div>

        <div style="margin:5px">
            <b-button variant="efficiency" size="sm" title="Efficiency %" >
                <font-awesome-icon :icon="['fas', 'reply-all']" size="sm" transform="rotate-120"></font-awesome-icon>
            </b-button>
            &nbsp;
            <span style="font-weight:bold; color:#2a5d77">
                {{totalOffload}}</span> {{$ml.get('ofeff')}} 
            &bull; 
            <span style="color:#2a5d77;font-weight:bold">
                {{totalMB_peer_computed}}
            </span>
            <b-img :src="require('@/assets/logo.svg')" style="height:1rem; margin-left:3px" />
        </div>

        <div style="margin:5px">
            <b-button variant="energy" size="sm" title="Energy saved %" >
                <font-awesome-icon size="sm" icon="leaf" />
            </b-button>
            &nbsp;
            <span style="color:#14BF98;font-weight:bold">
                {{totalEnergySaving}}</span> {{$ml.get('ofener')}}
                <span id="popover-help"><sup><b-badge variant="success">i</b-badge></sup></span>
                <b-popover
                    target="popover-help"
                    :title="$ml.get('ener')"
                    triggers="hover"
                    placement="bottomleft"
                    variant="light"
                >
                    <div v-html="$ml.get('energynote')"></div>
                    <div>
                        <b-img  :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px; margin: 5px 5px 5px 0px" /> 
                        <span v-html="$ml.get('lightexp')"></span>
                    </div>
                    <div>
                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px; margin: 5px 5px 5px 0px" /> 
                        <span v-html="$ml.get('houseexp')"></span>
                    </div>
                </b-popover>

            &bull;
            <span style="color:#14BF98;font-weight:bold">
                {{totalEnergySaved_computed}}
            </span>
            <span v-if="totalEnergySaved < 13000000">
                <b-img  :src="require('@/assets/bulbLeaf.svg')" style="max-height:25px; margin: 5px 10px 10px" />
                <span style="color:#14BF98;font-weight:bold">{{totalLightsSaved}}</span>&nbsp;
            </span>
            <span v-else>
                <b-img  :src="require('@/assets/greenHome.svg')" style="max-height:25px; margin: 5px 10px 10px" />
                <span style="color:#14BF98;font-weight:bold">{{totalHouseSaved}}</span>&nbsp;
            </span>
        </div>

        <div style="margin:5px">
            <b-button variant="views" size="sm" title="Number of viewers" >
                <font-awesome-icon size="sm" icon="eye" />
            </b-button>
            &nbsp;<span style="font-weight:bold">{{concurrentViews}}</span> {{$ml.get('viewersmax')}}
        </div>
    </b-row>

    <b-row class="justify-content-around" style="font-size:small">
        <!-- Views --> 
        <a id="views"></a>
        <b-col class="printviews" cols="12">
            <b-card no-body border-variant="msstream" class="mt-2">
                <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h6 style="margin:0px">
                        <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>&nbsp;
                        {{$ml.get('views')}}
                        <span v-if="globalPage && filter === '*'"> {{$ml.get('allvids2')}} </span>
                        <span class="noprint"  v-else-if="globalPage"> - {{filter}} </span>
                    </h6>
                </b-card-header>
                <b-row class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row v-if="isLoading" class="justify-content-center marginal">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0" style="text-align:center">
                                <font-awesome-icon :icon="['fas', 'database']" />                            
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    <strong>{{$ml.get('totaldatadel')}}</strong>
                                    <strong>{{totalMB_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    <strong>{{$ml.get('delfroms')}}</strong>
                                    <strong class="text-grey">{{totalMB_server_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3 align-items-center">
                                    <span>
                                        <strong>{{$ml.get('delfromp')}}</strong>
                                        <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                    </span>
                                    <strong class="text-darkblue">{{totalMB_peer_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showSecViews=!showSecViews">
                                <font-awesome-icon v-if="!showSecViews" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showSecViews" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0" style="text-align:center">
                                <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon>                            
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('maxavgv')}}
                                    <strong class="text-blue">{{concurrentViews}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    <span>
                                        {{$ml.get('maxavgcv')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </span>
                                    <strong>{{connectedViews}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showConcurrentViews=!showConcurrentViews">
                                <font-awesome-icon v-if="!showConcurrentViews" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showConcurrentViews" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                        
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'desktop']"></font-awesome-icon>                            
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                        {{$ml.get('viewtimemobile')}}
                                        <strong style="color:rgb(20, 191, 152)">{{totalViewingTimeMobile_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                        {{$ml.get('viewtimetablet')}}
                                        <strong>{{totalViewingTimeTablet_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                        {{$ml.get('viewtimedesktop')}}
                                        <strong style="color:#2F90B0">{{totalViewingTimeDesktop_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showChartViewingTimeDevice=!showChartViewingTimeDevice">
                                <font-awesome-icon v-if="!showChartViewingTimeDevice" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showChartViewingTimeDevice" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'wifi']"></font-awesome-icon>                            
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('viewtimecellular')}}
                                    <strong style="color:rgb(20, 191, 152)">{{totalViewingTimeCellular_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('viewtimeeth')}}
                                    <strong style="color:#2F90B0">{{totalViewingTimeWifi_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showChartViewingTimeNetwork=!showChartViewingTimeNetwork">
                                <font-awesome-icon v-if="!showChartViewingTimeNetwork" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showChartViewingTimeNetwork" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'play']"></font-awesome-icon>                            
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('plays')}}
                                    <strong>{{totalViews}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainViews=!showMainViews">
                                <font-awesome-icon v-if="!showMainViews" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainViews" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                   {{$ml.get('meanvt')}}&#134;
                                    <strong>{{meanViewingTime}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0" title="No chart for this value">
                                <font-awesome-icon :icon="['fas', 'minus-square']" style="color: #a80000"></font-awesome-icon>
                            </b-col>
                        </b-row>

                    </b-col>
                    <b-col v-if="showSecViews" sm="6" cols="12" class="centered">
                        <MBChart class="printCanvas" v-if="chartMBLoaded" :chartData="chartMBdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartMBLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showConcurrentViews" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats" >
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('maxavgv')}}
                                    <strong class="text-blue">{{concurrentViews}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    <span>
                                        {{$ml.get('maxavgcv')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </span>
                                    <strong>{{connectedViews}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showConcurrentViews=!showConcurrentViews">
                                <font-awesome-icon v-if="!showConcurrentViews" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showConcurrentViews" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <ConcurrentViewsChart class="printCanvas" v-if="chartConcurrentViewsLoaded" :chartData="chartConcurrentViewsdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartConcurrentViewsLoaded"/>
                    </b-col>
                </b-row>

                 <b-row v-if="showChartViewingTimeDevice" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'desktop']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('viewtimemobile')}}
                                    <strong style="color:rgb(20, 191, 152)">{{totalViewingTimeMobile_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('viewtimetablet')}}
                                    <strong>{{totalViewingTimeTablet_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('viewtimedesktop')}}
                                    <strong style="color:#2F90B0">{{totalViewingTimeDesktop_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showChartViewingTimeDevice=!showChartViewingTimeDevice">
                                <font-awesome-icon v-if="!showChartViewingTimeDevice" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showChartViewingTimeDevice" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <ViewingTimeDeviceChart class="printCanvas" v-if="chartViewingTimeDeviceLoaded" :chartData="chartViewingTimeDevicedata"/>
                        <EmptyChart class="printCanvas" v-if="!chartViewingTimeDeviceLoaded"/>
                    </b-col>
                </b-row>

                 <b-row v-if="showChartViewingTimeNetwork" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'wifi']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('viewtimecellular')}}
                                    <strong style="color:rgb(20, 191, 152)">{{totalViewingTimeCellular_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('viewtimeeth')}}
                                    <strong style="color:#2F90B0">{{totalViewingTimeWifi_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showChartViewingTimeNetwork=!showChartViewingTimeNetwork">
                                <font-awesome-icon v-if="!showChartViewingTimeNetwork" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showChartViewingTimeNetwork" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <ViewingTimeNetworkChart class="printCanvas" v-if="chartViewingTimeNetworkLoaded" :chartData="chartViewingTimeNetworkdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartViewingTimeNetworkLoaded"/>
                    </b-col>
                </b-row>
                
                <b-row v-if="showMeanViewingTime" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                   {{$ml.get('meanvt')}}&#134;
                                    <strong>{{meanViewingTime}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMeanViewingTime=!showMeanViewingTime">
                                <font-awesome-icon v-if="!showMeanViewingTime" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMeanViewingTime" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <MeanViewingTimeChart class="printCanvas" v-if="chartMeanViewingTimeLoaded" :chartData="chartMeanViewingTimedata"/>
                        <EmptyChart class="printCanvas" v-if="!chartMeanViewingTimeLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showMainViews" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('plays')}}
                                    <strong>{{totalViews}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainViews=!showMainViews">
                                <font-awesome-icon v-if="!showMainViews" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainViews" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <ViewsChart class="printCanvas" v-if="chartViewsLoaded" :chartData="chartViewsdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartViewsLoaded"/>
                    </b-col>
                </b-row>

                <b-row class="justify-content-center">
                    <b-col cols="11">
                        <p><small>{{$ml.get('viewersvalues')}}</small></p>
                        <p><small>&#134;{{$ml.get('meanvtvalues')}}</small></p>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
        <!--End of views panel -->


        <!-- Quality --> 
        <a id="quality"></a>
        <b-col class="printviews" cols="12">
            <b-card no-body border-variant="msstream" class="mt-2">
                <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h6 style="margin:0px">
                        <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon>&nbsp;
                        {{$ml.get('quality')}} 
                        <span v-if="globalPage && filter === '*'"> {{$ml.get('allvids2')}} </span>
                        <span class="noprint" v-else-if="globalPage"> - {{filter}} </span>
                    </h6>
                </b-card-header>
                <b-row class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row v-if="isLoading" class="justify-content-center marginal">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    <strong>{{$ml.get('highq')}}</strong>
                                    <strong class="text-blue">{{quality_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainQuality=!showMainQuality">
                                <font-awesome-icon v-if="!showMainQuality" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainQuality" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('highqdata')}}
                                    <strong class="text-blue">{{totalBestQuality_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('lowqdata')}}
                                    <strong style="color: #6c757d">{{totalOtherQualities_computed}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showQualities=!showQualities">
                                <font-awesome-icon v-if="!showQualities" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showQualities" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                &#x7E;
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('avgvb')}}
                                    <strong class="text-blue">{{averageBitrate}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showAverageBitrate=!showAverageBitrate">
                                <font-awesome-icon v-if="!showAverageBitrate" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showAverageBitrate" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('rebuffering')}}
                                    <strong>{{totalRebuf}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showRebuff=!showRebuff">
                                <font-awesome-icon v-if="!showRebuff" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showRebuff" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col v-if="showMainQuality" sm="6" cols="12" class="centered">
                        <PercentQualityChart class="printCanvas" v-if="chartPercentQualityLoaded" :chartData="chartPercentQualitydata"/>
                        <EmptyChart class="printCanvas" v-if="!chartPercentQualityLoaded"/>
                    </b-col>
                </b-row>
                
                <b-row v-if="showQualities" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('highqdata')}}
                                    <strong class="text-blue">{{totalBestQuality_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('lowqdata')}}
                                    <strong style="color:#6c757d">{{totalOtherQualities_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 mt-3">
                                    SD 480p
                                    <strong style="color:#ba0000">{{totalSD_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    HD 720p
                                    <strong style="color:#ba008f">{{totalHD_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    Full HD 1080p
                                    <strong style="color:#2F90B0">{{totalFullHD_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    2K 1440p
                                    <strong style="color:#aac8d4">{{total2K_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    4K 2160p
                                    <strong style="color:rgb(20, 191, 152)">{{total4K_computed}} </strong>
                                </b-row>
                                <!--
                                <b-row class="justify-content-center">
                                    8K 4320p:&nbsp;
                                    <strong style="color:rgb(21, 62, 82)">{{total8K_computed}} </strong>
                                </b-row>
                                -->
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showQualities=!showQualities">
                                <font-awesome-icon v-if="!showQualities" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showQualities" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <QualitiesChart class="printCanvas" v-if="chartQualitiesLoaded" :chartData="chartQualitiesdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartQualitiesLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showAverageBitrate" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                &#x7E;
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('avgvb')}}
                                    <strong class="text-blue">{{averageBitrate}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showAverageBitrate=!showAverageBitrate">
                                <font-awesome-icon v-if="!showAverageBitrate" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showAverageBitrate" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <BitrateChart class="printCanvas" v-if="chartBitrateLoaded" :chartData="chartBitratedata"/>
                        <EmptyChart class="printCanvas" v-if="!chartBitrateLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showRebuff" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('rebuffering')}}
                                    <strong>{{totalRebuf}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('rebuffmin')}} 
                                    <strong class="text-red">{{totalRebufMin_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('playedmin')}} 
                                    <strong class="text-blue">{{totalViewingTime_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showRebuff=!showRebuff">
                                <font-awesome-icon v-if="!showRebuff" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showRebuff" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <RebufChart class="printCanvas" v-if="chartRebufLoaded" :chartData="chartRebufdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartRebufLoaded"/>
                    </b-col>
                </b-row>
                <b-row class="justify-content-center">
                    <b-col cols="11">
                        <p><small>{{$ml.get('videodata')}}</small></p>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>

        <!-- Efficiency --> 
        <a id="efficiency"></a>
        <b-col class="printviews" cols="12">
            <b-card no-body border-variant="msstream" class="mt-2">
                <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h6 style="margin:0px">
                        <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>&nbsp;
                        {{$ml.get('efficiency')}} 
                        <span v-if="globalPage && filter === '*'"> {{$ml.get('allvids2')}} </span>
                        <span class="noprint"  v-else-if="globalPage"> - {{filter}} </span>
                    </h6>
                </b-card-header>
                <b-row class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row v-if="isLoading" class="justify-content-center marginal">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon>                            
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    <strong>{{$ml.get('effdata')}}</strong>
                                    <strong class="text-darkblue">{{totalOffload}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <strong>
                                        {{$ml.get('effdata')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </strong>
                                    <strong class="text-blue">{{totalOffloadConnected}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEfficiency=!showMainEfficiency">
                                <font-awesome-icon v-if="!showMainEfficiency" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEfficiency" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('totaldatadel')}}
                                    <strong>{{totalMB_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    {{$ml.get('delfroms')}}
                                    <strong class="text-grey">{{totalMB_server_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    <span>
                                        {{$ml.get('delfromp')}}
                                        <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                    </span>
                                    <strong class="text-darkblue">{{totalMB_peer_computed}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showData=!showData">
                                <font-awesome-icon v-if="!showData" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showData" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('totalvt')}}
                                    <strong>{{totalViewingTime_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    {{$ml.get('delfroms')}}
                                    <strong class="text-grey">{{totalsec_server_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    <span>
                                        {{$ml.get('delfromp')}}
                                        <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                    </span>
                                    <strong class="text-darkblue">{{totalsec_peer_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 mt-2">
                                    {{$ml.get('efftime')}}
                                    <strong class="text-darkblue">{{totalOffloadTime}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showSec=!showSec">
                                <font-awesome-icon v-if="!showSec" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showSec" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col v-if="showMainEfficiency" sm="6" cols="12" class="centered">
                        <OffloadChart class="printCanvas" v-if="chartOffloadLoaded" :chartData="chartOffloaddata"/>
                        <EmptyChart class="printCanvas" v-if="!chartOffloadLoaded"/>
                    </b-col>
                </b-row>
                
                <b-row v-if="showData" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('totaldatadel')}}
                                    <strong>{{totalMB_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    {{$ml.get('delfroms')}}
                                    <strong class="text-grey">{{totalMB_server_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    <span>
                                        {{$ml.get('delfromp')}}
                                        <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                    </span>
                                    <strong class="text-darkblue">{{totalMB_peer_computed}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showData=!showData">
                                <font-awesome-icon v-if="!showData" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showData" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <MBChart class="printCanvas" v-if="chartMBLoaded" :chartData="chartMBdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartMBLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showSec" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('totalvt')}}
                                    <strong>{{totalViewingTime_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    {{$ml.get('delfroms')}}
                                    <strong class="text-grey">{{totalsec_server_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 ml-3">
                                    <span>
                                        {{$ml.get('delfromp')}}
                                        <b-img :src="require('@/assets/logo.svg')" style="margin-left:5px; height:1rem" />
                                    </span>
                                    <strong class="text-darkblue">{{totalsec_peer_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1 mt-3">
                                    {{$ml.get('efftime')}}
                                    <strong class="text-darkblue">{{totalOffloadTime}}</strong>
                                </b-row>

                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showSec=!showSec">
                                <font-awesome-icon v-if="!showSec" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showSec" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <ViewingTimeChart class="printCanvas" v-if="chartViewingTimeLoaded" :chartData="chartViewingTimedata"/>
                        <EmptyChart class="printCanvas" v-if="!chartViewingTimeLoaded"/>
                    </b-col>
                </b-row>
                <b-row class="justify-content-center">
                    <b-col cols="11">
                        <p><small>{{$ml.get('effnote')}}</small></p>
                    </b-col>
                </b-row>

            </b-card>
        </b-col>

        <!-- Energy --> 
        <a id="energy"></a>
        <b-col class="printviews" cols="12">
            <b-card no-body border-variant="msstream" class="mt-2">
                <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h6 style="margin:0px">
                        <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>&nbsp;
                        {{$ml.get('ener')}}
                        <span v-if="globalPage && filter === '*'"> {{$ml.get('allvids2')}} </span>
                        <span class="noprint"  v-else-if="globalPage"> - {{filter}} </span>
                    </h6>
                </b-card-header>
                <b-row class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row v-if="isLoading" class="justify-content-center marginal">
                            <b-spinner label="Loading..."></b-spinner>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/logo.svg')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    <strong>{{$ml.get('enersaved')}}</strong>
                                    <strong class="text-green">{{totalEnergySaving}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <strong>
                                        {{$ml.get('enersaved')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </strong>
                                    <b-popover
                                        target="connview"
                                        triggers="hover"
                                        placement="bottomleft"
                                        variant="light"
                                    >
                                    {{$ml.get('connview')}}
                                    </b-popover>
                                    <strong class="text-blue">{{totalEnergySavingConnected}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showEnergySaving=!showEnergySaving">
                                <font-awesome-icon v-if="!showEnergySaving" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showEnergySaving" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                        
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('enersaved')}} 
                                    <strong class="text-green">{{totalEnergySavingIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <span>
                                        {{$ml.get('enersaved')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </span>
                                    <strong class="text-blue">{{totalEnergySavingConnectedIEA}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showEnergySavingIEA=!showEnergySavingIEA">
                                <font-awesome-icon v-if="!showEnergySavingIEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showEnergySavingIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('enersaved')}} 
                                    <strong class="text-green">{{totalEnergySavingSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <span>
                                        {{$ml.get('enersaved')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </span>
                                    <strong class="text-blue">{{totalEnergySavingConnectedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showEnergySavingSHIFT=!showEnergySavingSHIFT">
                                <font-awesome-icon v-if="!showEnergySavingSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showEnergySavingSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'leaf']" transform=""></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('enersaved')}} 
                                    <strong class="text-green">{{totalEnergySavingDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <span>
                                        {{$ml.get('enersaved')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </span>
                                    <strong class="text-blue">{{totalEnergySavingConnectedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showEnergySavingDimpact=!showEnergySavingDimpact">
                                <font-awesome-icon v-if="!showEnergySavingDimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showEnergySavingDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>                         

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/logo.svg')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}}                                    
                                    <strong>{{totalEnergy_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('delivery')}}                                    
                                    <span v-if="totalEnergySaved < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSaved}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSaved}}</span>
                                    </span>
                                    &nbsp;
                                    &nbsp;                                   
                                    <strong class="text-green">{{totalEnergySaved_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}}
                                    <strong>{{totalEnergyDevices_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergy=!showMainEnergy">
                                <font-awesome-icon v-if="!showMainEnergy" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergy" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}}                                    
                                    <strong>{{totalEnergy_computedIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('delivery')}}                                    
                                    <span v-if="totalEnergySavedIEA < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSavedIEA}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSavedIEA}}</span>
                                    </span>
                                    &nbsp;
                                    &nbsp;
                                    <strong class="text-green">{{totalEnergySaved_computedIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}}                                    
                                    <strong>{{totalEnergyDevices_computedIEA}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergyIEA=!showMainEnergyIEA">
                                <font-awesome-icon v-if="!showMainEnergyIEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergyIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}}                                    
                                    <strong>{{totalEnergy_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('delivery')}}                                    
                                    <span v-if="totalEnergySavedSHIFT < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSavedSHIFT}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSavedSHIFT}}</span>
                                    </span>
                                    &nbsp;
                                    &nbsp;                                   
                                    <strong class="text-green">{{totalEnergySaved_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}}                                    
                                    <strong>{{totalEnergyDevices_computedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergySHIFT=!showMainEnergySHIFT">
                                <font-awesome-icon v-if="!showMainEnergySHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergySHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}}                                    
                                    <strong>{{totalEnergy_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('viewing')}}                                    
                                    <span v-if="totalEnergySavedDimpact < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSavedDimpact}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSavedDimpact}}</span>
                                    </span>    
                                    &nbsp;
                                    &nbsp;                               
                                    <strong class="text-green">{{totalEnergySaved_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}}                                    
                                    <strong>{{totalEnergyDevices_computedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergyDimpact=!showMainEnergyDimpact">
                                <font-awesome-icon v-if="!showMainEnergyDimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergyDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/logo.svg')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computed}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2=!showCo2">
                                <font-awesome-icon v-if="!showCo2" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computedIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computedIEA}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2IEA=!showCo2IEA">
                                <font-awesome-icon v-if="!showCo2IEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2IEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2SHIFT=!showCo2SHIFT">
                                <font-awesome-icon v-if="!showCo2SHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2SHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2Dimpact=!showCo2Dimpact">
                                <font-awesome-icon v-if="!showCo2Dimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2Dimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/logo.svg')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computed}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWater=!showWater">
                                <font-awesome-icon v-if="!showWater" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWater" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computedIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computedIEA}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWaterIEA=!showWaterIEA">
                                <font-awesome-icon v-if="!showWaterIEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWaterIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWaterSHIFT=!showWaterSHIFT">
                                <font-awesome-icon v-if="!showWaterSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWaterSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>

                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>                            
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWaterDimpact=!showWaterDimpact">
                                <font-awesome-icon v-if="!showWaterDimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWaterDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>

                    <b-col v-if="showEnergySaving" sm="6" cols="12" class="centered">
                        <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoaded" :chartData="chartEnergySavingdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showEnergySavingIEA" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('enersaved')}}
                                    <strong class="text-green">{{totalEnergySavingIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <span>
                                        {{$ml.get('enersaved')}}
                                        <b-icon id="connview" icon="gear-wide-connected" />
                                    </span>
                                    <strong class="text-blue">{{totalEnergySavingConnectedIEA}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showEnergySavingIEA=!showEnergySavingIEA">
                                <font-awesome-icon v-if="!showEnergySavingIEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showEnergySavingIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoadedIEA" :chartData="chartEnergySavingdataIEA"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoadedIEA"/>
                    </b-col>
                </b-row>

                <b-row v-if="showEnergySavingSHIFT" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('enersaved')}} 
                                    <strong class="text-green">{{totalEnergySavingSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <span>
                                        {{$ml.get('enersaved')}}
                                        <b-icon id="connview" icon="gear-wide-connected"/>
                                    </span>
                                    <strong class="text-blue">{{totalEnergySavingConnectedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showEnergySavingSHIFT=!showEnergySavingSHIFT">
                                <font-awesome-icon v-if="!showEnergySavingSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showEnergySavingSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoadedSHIFT" :chartData="chartEnergySavingdataSHIFT"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoadedSHIFT"/>
                    </b-col>
                </b-row>

                <b-row v-if="showEnergySavingDimpact" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('enersaved')}} 
                                    <strong class="text-green">{{totalEnergySavingDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1" title="Connected viewers only">
                                    <span>
                                        {{$ml.get('enersaved')}}
                                        <b-icon id="connview" icon="gear-wide-connected"/>
                                    </span>
                                    <strong class="text-blue">{{totalEnergySavingConnectedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showEnergySavingDimpact=!showEnergySavingDimpact">
                                <font-awesome-icon v-if="!showEnergySavingDimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showEnergySavingDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <EnergySavingChart class="printCanvas" v-if="chartEnergySavingLoadedDimpact" :chartData="chartEnergySavingdataDimpact"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergySavingLoadedDimpact"/>
                    </b-col>
                </b-row>   

                <b-row v-if="showMainEnergy" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/logo.svg')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <strong>{{totalEnergy_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <span v-if="totalEnergySaved < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSaved}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSaved}}</span>
                                    </span>
                                    &nbsp;
                                    &nbsp;
                                    <strong class="text-green">{{totalEnergySaved_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}} 
                                    <strong>{{totalEnergyDevices_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergy=!showMainEnergy">
                                <font-awesome-icon v-if="!showMainEnergy" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergy" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <EnergyChart class="printCanvas" v-if="chartEnergyLoaded" :chartData="chartEnergydata"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showMainEnergyIEA" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <strong>{{totalEnergy_computedIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <span v-if="totalEnergySavedIEA < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSavedIEA}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSavedIEA}}</span>
                                    </span>
                                    &nbsp;
                                    &nbsp;
                                    <strong class="text-green">{{totalEnergySaved_computedIEA}}</strong>
                                </b-row>
                               <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}} 
                                    <strong>{{totalEnergyDevices_computedIEA}}</strong>
                                </b-row>                                
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergyIEA=!showMainEnergyIEA">
                                <font-awesome-icon v-if="!showMainEnergyIEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergyIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <EnergyChart class="printCanvas" v-if="chartEnergyLoadedIEA" :chartData="chartEnergydataIEA"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedIEA"/>
                    </b-col>
                </b-row>

                <b-row v-if="showMainEnergySHIFT" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <strong>{{totalEnergy_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="align-items-center justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <span v-if="totalEnergySavedSHIFT < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSavedSHIFT}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSavedSHIFT}}</span>
                                    </span>
                                    &nbsp;
                                    &nbsp;
                                    <strong class="text-green">{{totalEnergySaved_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}} 
                                    <strong>{{totalEnergyDevices_computedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergySHIFT=!showMainEnergySHIFT">
                                <font-awesome-icon v-if="!showMainEnergySHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergySHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <EnergyChart class="printCanvas" v-if="chartEnergyLoadedSHIFT" :chartData="chartEnergydataSHIFT"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedSHIFT"/>
                    </b-col>
                </b-row>

                <b-row v-if="showMainEnergyDimpact" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('poweren')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <strong>{{totalEnergy_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="align-items-center justify-content-between m-1">
                                    {{$ml.get('powerens')}}
                                    <br>
                                    {{$ml.get('delivery')}} 
                                    <span v-if="totalEnergySavedDimpact < 13000000">
                                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalLightsSavedDimpact}}</span>
                                    </span>
                                    <span v-else>
                                        <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px" />
                                        &nbsp;<span style="color:#14BF98;font-weight:bold">{{totalHouseSavedDimpact}}</span>
                                    </span>
                                    &nbsp;
                                    &nbsp;
                                    <strong class="text-green">{{totalEnergySaved_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('powerend')}}
                                    <br>
                                    {{$ml.get('viewing')}} 
                                    <strong>{{totalEnergyDevices_computedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showMainEnergyDimpact=!showMainEnergyDimpact">
                                <font-awesome-icon v-if="!showMainEnergyDimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showMainEnergyDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <EnergyChart class="printCanvas" v-if="chartEnergyLoadedDimpact" :chartData="chartEnergydataDimpact"/>
                        <EmptyChart class="printCanvas" v-if="!chartEnergyLoadedDimpact"/>
                    </b-col>
                </b-row>

                <b-row v-if="showCo2" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/logo.svg')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computed}} </strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computed}} </strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2=!showCo2">
                                <font-awesome-icon v-if="!showCo2" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <Co2Chart class="printCanvas" v-if="chartCo2Loaded" :chartData="chartCo2data"/>
                        <EmptyChart class="printCanvas" v-if="!chartCo2Loaded"/>
                    </b-col>
                </b-row>
                
                <b-row v-if="showCo2IEA" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>                                
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computedIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computedIEA}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2IEA=!showCo2IEA">
                                <font-awesome-icon v-if="!showCo2IEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2IEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <Co2Chart class="printCanvas" v-if="chartCo2LoadedIEA" :chartData="chartCo2dataIEA"/>
                        <EmptyChart class="printCanvas" v-if="!chartCo2LoadedIEA"/>
                    </b-col>
                </b-row>

                <b-row v-if="showCo2SHIFT" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2SHIFT=!showCo2SHIFT">
                                <font-awesome-icon v-if="!showCo2SHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2SHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <Co2Chart class="printCanvas" v-if="chartCo2LoadedSHIFT" :chartData="chartCo2dataSHIFT"/>
                        <EmptyChart class="printCanvas" v-if="!chartCo2LoadedSHIFT"/>
                    </b-col>
                </b-row>

                <b-row v-if="showCo2Dimpact" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2rej')}}
                                    <strong>{{totalCo2_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('co2saved')}}
                                    <strong class="text-green">{{totalCo2Saved_computedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showCo2Dimpact=!showCo2Dimpact">
                                <font-awesome-icon v-if="!showCo2Dimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showCo2Dimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <Co2Chart class="printCanvas" v-if="chartCo2LoadedDimpact" :chartData="chartCo2dataDimpact"/>
                        <EmptyChart class="printCanvas" v-if="!chartCo2LoadedDimpact"/>
                    </b-col>
                </b-row>

                <b-row v-if="showWater" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/logo.svg')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computed}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computed}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWater=!showWater">
                                <font-awesome-icon v-if="!showWater" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWater" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <WaterChart class="printCanvas" v-if="chartWaterLoaded" :chartData="chartWaterdata"/>
                        <EmptyChart class="printCanvas" v-if="!chartWaterLoaded"/>
                    </b-col>
                </b-row>

                <b-row v-if="showWaterIEA" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/iea.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computedIEA}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computedIEA}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWaterIEA=!showWaterIEA">
                                <font-awesome-icon v-if="!showWaterIEA" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWaterIEA" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <WaterChart class="printCanvas" v-if="chartWaterLoadedIEA" :chartData="chartWaterdataIEA"/>
                        <EmptyChart class="printCanvas" v-if="!chartWaterLoadedIEA"/>
                    </b-col>
                </b-row>

                <b-row v-if="showWaterSHIFT" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/shift.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computedSHIFT}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computedSHIFT}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWaterSHIFT=!showWaterSHIFT">
                                <font-awesome-icon v-if="!showWaterSHIFT" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWaterSHIFT" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <WaterChart class="printCanvas" v-if="chartWaterLoadedSHIFT" :chartData="chartWaterdataSHIFT"/>
                        <EmptyChart class="printCanvas" v-if="!chartWaterLoadedSHIFT"/>
                    </b-col>
                </b-row>

                <b-row v-if="showWaterDimpact" class="rowStats">
                    <b-col sm="6" md="5" lg="4" xl="3" cols="12 mb-2">
                        <b-row class="rowDetailStats">
                            <b-col cols="1 p-0 centered">
                                <font-awesome-icon :icon="['fas', 'water']"></font-awesome-icon>
                                <b-img
                                class="logoEn"
                                :src="require('@/assets/dimpact.png')"
                                fluid
                                ></b-img>
                            </b-col>
                            <b-col cols="10">
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watercon')}}
                                    <strong>{{totalWater_computedDimpact}}</strong>
                                </b-row>
                                <b-row class="justify-content-between m-1">
                                    {{$ml.get('watersav')}}
                                    <strong class="text-green">{{totalWaterSaved_computedDimpact}}</strong>
                                </b-row>
                            </b-col>
                            <b-col cols="1 p-0 pointerElt2" @click="showWaterDimpact=!showWaterDimpact">
                                <font-awesome-icon v-if="!showWaterDimpact" :icon="['far', 'square']"></font-awesome-icon>
                                <font-awesome-icon v-if="showWaterDimpact" :icon="['fas', 'check-square']"></font-awesome-icon>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col sm="6" cols="12" class="centered">
                        <WaterChart class="printCanvas" v-if="chartWaterLoadedDimpact" :chartData="chartWaterdataDimpact"/>
                        <EmptyChart class="printCanvas" v-if="!chartWaterLoadedDimpact"/>
                    </b-col>
                </b-row>


                <b-row class="m-1 ml-3 small">
                    {{$ml.get('energynote')}}
                </b-row>
                <b-row class="m-1 ml-3 small">
                    {{$ml.get('energynote2')}}
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [1]&nbsp;<a style="word-break: break-word;" href="https://www.iea.org/commentaries/the-carbon-footprint-of-streaming-video-fact-checking-the-headlines">IEA (2020), The carbon footprint of streaming video: fact-checking the headlines, IEA, Paris.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [2]&nbsp;<a href="https://theshiftproject.org/wp-content/uploads/2020/06/2020-06_Did-TSP-overestimate-the-carbon-footprint-of-online-video_EN.pdf">The Shift Project (2020).</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [3] &nbsp; <a href="https://computingwithinlimits.org/2022/papers/limits22-final-Makonin.pdf">Makonin et al., "Calculating the Carbon Footprint of Streaming Media: Beyond the Myth of Efficiency", Eighth Workshop on Computing within Limits, 2022.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [4] &nbsp; <a href="https://www.epa.gov/greenvehicles/greenhouse-gas-emissions-typical-passenger-vehicle">United States EPA, 2022.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [5] &nbsp; <a href="https://pubs.rsc.org/en/content/articlelanding/2015/EW/C5EW00026B">Mekonnen et al., "The consumptive water footprint of electricity and heat: a global assessment", Environmental Science: Water Research & Technology journal, 1(3): 285–297, 2015.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [6] &nbsp; <a href="https://www.iea.org/data-and-statistics/data-tools/energy-statistics-data-browser">IEA (2022), Energy Statistics Data Browser, IEA, Paris.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [7] &nbsp; <a href="https://ourworldindata.org/grapher/carbon-intensity-electricity?tab=table">Our World in Data: Carbon Intensity Electricity, 2021.</a>
                </b-row>
                <b-row class="m-1 ml-3 small">
                    [8] &nbsp; <a href="https://dimpact.org/downloadResourceFile?resource=2">DImpact, Methodology Estimating the carbon impacts of serving digital media and entertainment products</a>
                </b-row>
                <b-row class="mt-3 ml-3 mb-1 small align-items-center">
                        <b-img :src="require('@/assets/bulbLeaf.svg')" style="max-height:15px; width:15px; " /> 
                        &nbsp;<strong class="text-green">1</strong>&nbsp;
                        <span v-html="$ml.get('lightexp')"></span>
                </b-row>
                <b-row class="ml-3 mb-3 small align-items-center">
                    <b-img :src="require('@/assets/greenHome.svg')" style="max-height:15px; ; width:15px; " /> 
                    &nbsp;<strong class="text-green">1</strong>&nbsp;
                    <span v-html="$ml.get('houseexp')"></span>
                </b-row>
            </b-card>
        </b-col>

        <!-- CDN --> 
        <a id="cdn"></a>
        <b-col v-if="this.$auth.getMyUser().client_infos[0].bunny || this.$auth.getMyUser().client_infos[0].type === 'plugin'" class="printviews" cols="12">
            <b-card no-body border-variant="msstream" class="mt-2">
                <b-card-header header-bg-variant="msstream" header-text-variant="white" class="text-center">
                    <h6 style="margin:0px" v-if="this.$auth.getMyUser().client_infos[0].bunny">
                        <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>&nbsp;
                        CDN
                    </h6>
                    <h6 style="margin:0px" v-if="this.$auth.getMyUser().client_infos[0].type === 'plugin'">
                        <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon>&nbsp;
                        {{$ml.get('map')}}
                        <span v-if="globalPage && filter === '*'"> {{$ml.get('allvids2')}} </span>
                        <span class="noprint"  v-else-if="globalPage"> - {{filter}} </span>
                    </h6>
                </b-card-header>
                <b-row class="justify-content-center align-items-center" style="margin-top:20px; margin-bottom:20px">
                   <b-col md="6" cols="10">
                       <b-row v-for="geo in geoCDN" v-bind:key="geo.Name" style="margin-bottom: 10px;">
                            <b-col cols="6" style="text-align:right;">
                                {{geo.Name}}:
                            </b-col>
                            <b-col cols="6" class="text-blue">
                                <strong>{{geo._sumData}}</strong>
                            </b-col>
                        </b-row>
                   </b-col>
                </b-row>
                <b-row class="justify-content-center align-items-center" style="margin-top:20px; margin-bottom:20px">
                    <b-col md="10" cols="10">
                    <l-map style="height: 800px; width:100%" :zoom="zoom" :center="center">
                        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                        <l-marker v-for="marker, index in markersCDN" v-bind:key=index :lat-lng="marker.coordinates">
                            <l-popup :content="marker.description"></l-popup>
                        </l-marker>
                    </l-map>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>

    </b-row>

    <!-- Select Video-->
    <b-modal ref="selectVideo" hide-footer hide-header @hidden="cleanVideos" @open="prepareModalSelectionVideos">
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'link']" />
          {{$ml.get('selectvidana')}} 
        </h5>
      </div>
      <b-row class="justify-content-center">
        <b-form @submit.prevent="videos = []; getVideos()">
          <b-form-group style="margin: 10px; width:300px">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-button variant="db-sb" type="submit" class="input-group-text">
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-input-group-prepend>
              <b-form-input v-model="searchBar"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-form>
      </b-row>
      <b-row>
        <div v-for="video in videos" v-bind:key="video.uuid" v-bind:class="{
          mycard5: true, 
          clickable: true,
          oldcard: (selectedVideosTmp.includes((video.authorizationKey && video.authorizationKey.indexOf('cam') > -1) ? video.authorizationKey : video.uuid))
          }" class='col-sm-4 col-6' @click="selectVideo(video)">
          <div>
            <h6 style="color: #2a5d77; font-size:80%; text-align:center; word-break: break-word">{{video.title}}</h6>
            <b-row class="justify-content-center">
              <div class="previewContainer" style="z-index:1">
                <b-img class="previewImg"  style="object-fit:contain; cursor:pointer" :src="video.manifest.thumbnail" @error="imgUrlAlt" fluid/>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
      <b-pagination style="margin:20px" size="sm" align="center" :limit="10" :total-rows="totalPages" v-model="videoPage" :per-page="1" @input="getVideos()" />

      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" @click="loadSelectedVideos();hideModal('selectVideo')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
          OK
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('selectVideo')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
  </b-modal>

  <!-- Select Videos plugin -->
      <b-modal ref="selectVideoPlugin" hide-footer hide-header @hidden="cleanVideos" @open="prepareModalSelectionVideos">
      <div class="d-block text-center">
        <h5 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'link']" />
          Select videos to display their analytics 
        </h5>
      </div>
      <b-row class="justify-content-center">
        <b-form @submit.prevent="videos = []; getPluginVideosList()">
          <b-form-group style="margin: 10px; width:300px">
            <b-input-group size="sm">
              <b-input-group-prepend>
                <b-button variant="db-sb" type="submit" class="input-group-text">
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-input-group-prepend>
              <b-form-input v-model="searchBar"></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-form>
                <b-row class="align-items-center justify-content-center m-1">
            <b-button size="sm" variant="mswarning" @click="updateVideoPluginList" title="Update video list (can take time)">
                <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon>
            </b-button>
        </b-row>
      </b-row>
      <b-row>
        <div v-for="video in videosPlugin" v-bind:key="video.videoID" v-bind:class="{
          mycard5: true, 
          clickable: true,
          oldcard: (selectedVideosTmp.includes(video.videoID))
          }" class='col-sm-12 col-12 p-2'>
            <div @click="selectVideoPlugin(video)">
                <h6 title="Video title" style="color: #2a5d77; text-align:center; word-break: break-word;">{{video.videoID}}</h6>
                <b-row class="justify-content-center align-items-center" title="Video creation date" style="font-size:small">
                    <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
                    &nbsp;{{video._created}}
                </b-row>
             </div>
        </div>
      </b-row>
      <b-pagination style="margin:20px" size="sm" align="center" :limit="10" :total-rows="totalPages" v-model="videoPage" :per-page="1" @input="getPluginVideosList()" />

      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" @click="loadSelectedVideos();hideModal('selectVideoPlugin')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'check']" />
          Validate
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('selectVideoPlugin')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'times']" />
          Cancel
        </b-btn>
      </b-row>
  </b-modal>

<!--
</b-card>
-->
</div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
import MBChart from '@/components/analytics/GraphType/MBChart.vue';
import ViewsChart from '@/components/analytics/GraphType/ViewsChart.vue';
import ViewingTimeChart from '@/components/analytics/GraphType/ViewingTimeChart.vue';
import ViewingTimeDeviceChart from '@/components/analytics/GraphType/ViewingTimeDeviceChart.vue';
import ViewingTimeNetworkChart from '@/components/analytics/GraphType/ViewingTimeNetworkChart.vue';
import RebufChart from '@/components/analytics/GraphType/RebufChart.vue';
import QualitiesChart from '@/components/analytics/GraphType/QualitiesChart.vue';
import PercentQualityChart from '@/components/analytics/GraphType/PercentQualityChart.vue';
import BitrateChart from '@/components/analytics/GraphType/BitrateChart.vue';
import MeanViewingTimeChart from '@/components/analytics/GraphType/MeanViewingTimeChart.vue';
import ConcurrentViewsChart from '@/components/analytics/GraphType/ConcurrentViewsChart.vue';
import OffloadChart from '@/components/analytics/GraphType/OffloadChart.vue';
import EnergyChart from '@/components/analytics/GraphType/EnergyChart.vue';
import Co2Chart from '@/components/analytics/GraphType/Co2Chart.vue';
import EnergySavingChart from '@/components/analytics/GraphType/EnergySavingChart.vue';
import WaterChart from '@/components/analytics/GraphType/WaterChart.vue';

import { LMap, LTileLayer, LMarker,LPopup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { Icon } from 'leaflet';

import countryData from '@/services/countryCode.json'

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


import EmptyChart from '@/components/analytics/GraphType/EmptyChart.vue';
import AnalyticsService from "@/services/analytics.service";
import VideoService from "@/services/video.service";
import { EventBus } from '@/event-bus.js';
var videoService = new VideoService();
var analyticsService = new AnalyticsService();

let moment = require("moment");
let myDateBegin = new Date();

export default {
  name: 'CompleteAnalytics',
  components: {
    MBChart,
    ViewsChart,
    ViewingTimeChart,
    ViewingTimeDeviceChart,
    ViewingTimeNetworkChart,
    RebufChart,
    QualitiesChart,
    PercentQualityChart,
    BitrateChart,
    MeanViewingTimeChart,
    ConcurrentViewsChart,
    OffloadChart,
    EnergyChart,
    Co2Chart,
    EnergySavingChart,
    DatePicker,
    EmptyChart,
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    WaterChart
  },
  props: [
      'video'
  ],
  data: function() {
    return {

        //Map
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution:'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        zoom: 2.5,
        center: [47.41322, 0],
        bounds: null,
        markersCDN:[],
        countryDataRaw : countryData,
        countryCode : undefined, 

        clientView: (this.$auth.getMyUser().roles.indexOf('admin') > -1) ? this.$auth.getMyClientView() || this.$auth.getMyUser().client : this.$auth.getMyUser().client,
        indiceCo2: 442, //world value. Europe: 262gCo2/Kwh, France: 58gcO2/Kwh
        //show
        timeRangeType: true,
        showAverageBitrate: false,
        showRebuff: false,
        showData: false,
        showSec: false,
        showSecViews: true,
        showMeanViewingTime: false,
        showTotalViewingTime: false,
        showConcurrentViews: false,
        showCo2: false,
        showCo2IEA: false,
        showCo2SHIFT: false,
        showCo2Dimpact: false,
        showEnergySaving: true,
        showEnergySavingIEA: false,
        showEnergySavingSHIFT: false,
        showEnergySavingDimpact: false,
        showWater:false,
        showWaterIEA:false,
        showWaterSHIFT:false,
        showWaterDimpact:false,
        showQualities: false,
        showMainQuality: true,
        showMainEfficiency: true,
        showMainEnergy: false,
        showMainEnergyIEA: false,
        showMainEnergySHIFT: false,
        showMainEnergyDimpact: false,
        showMainViews: false,
        showChartViewingTimeDevice: false,
        showChartViewingTimeNetwork: false,
        // Options
        keys: [],
        key: '',
        range: {
            end: new Date(),
            start: new Date(myDateBegin.getFullYear(),  myDateBegin.getMonth(), myDateBegin.getDate() - 1, myDateBegin.getHours(), 0, 0),
            dispEnd: '1',
            dispStart: '1',
        },
        dateStart: '',
        dateEnd: '',
        interval: '1h',
        intervalDisplayed: 'auto',
        interval_client: '10s',
        filter: '*',
        globalPage: (this.video.uuid === '*') ? true : false,
        dateLabel: '1d',
        dateLabelOptions: [
            {text:'Last 1 hours', value: '1h'},
            {text:'Last 3 hours', value: '3h'},
            {text:'Last 6 hours', value: '6h'},
            {text:'Last 12 hours', value: '12h'},
            {text:'Last 24 hours', value: '1d'},
            {text:'Last 2 days', value: '2d'},
            {text:'Last 7 days', value: '7d'},
            {text:'Last 14 days', value: '14d'},
            {text:'Last 30 days', value: '30d'},
            {text:'Custom', value: 'custom'}
        ],
        intervalOptions: [
            {text:'Auto', value: 'auto'},
            {text:'1 min', value: '1m', tenSeconds: 6},
            {text:'5 min', value: '5m', tenSeconds: 30},
            {text:'10 min', value: '10m', tenSeconds: 60},
            {text:'30 min', value: '30m', tenSeconds: 190},
            {text:'1 hour', value: '1h', tenSeconds: 360},
            {text:'3 hours', value: '3h', tenSeconds: 1080},
            {text:'6 hours', value: '6h', tenSeconds: 2160},
            {text:'1 day', value: '1d', tenSeconds: 8640},
            {text:'2 days', value: '2d', tenSeconds: 17280},
            {text:'7 days', value: '7d', tenSeconds: 60480},
            {text:'14 days', value: '14d', tenSeconds: 120960},
            {text:'30 days', value: '30d', tenSeconds: 259200},
            {text:'100 days', value: '100d', tenSeconds: 864000}
        ],
        calendarValidate: false,      
        // Raw Data
        MB_peer: [],
        MB_peer_connected:[],
        MB_server: [],
        MB_server_connected: [],
        sec_peer: [],
        sec_server: [],
        sec_peer_connected: [],
        sec_server_connected: [],
        sec_rebuf: [],
        bestQuality: [],
        otherQualities: [],
        glitches: [],
        client_uuid: [],
        new_client_uuid: [],
        new_client_number: [],
        represented_client: [],
        represented_client2: [],
        represented_connected_client:[],
        totalSD: 0,
        totalHD: 0,
        totalFullHD: 0,
        total2K: 0,
        total4K: 0,
        total8K: 0,
        totalMaxQuality: 0,
        totalOtherQualities: 0,
        timeLQ: [],
        timeHQ : [],
        networkWifi: [],
        networkCellular: [],
        devicePhone : [],
        deviceTablet: [],
        deviceComputer: [],
        timeLQConnected: [],
        timeHQConnected : [],
        networkWifiConnected: [],
        networkCellularConnected: [],
        devicePhoneConnected : [],
        deviceTabletConnected: [],
        deviceComputerConnected: [],
        networkWifiData: [],
        networkCellularData: [],
        devicePhoneData : [],
        deviceTabletData: [],
        deviceComputerData: [],


        /**QUANTEEC */
        energyNormal: [],
        energyQuanteec: [],
        energyDevices: [],
        energySaved: [],
        co2Normal: [],
        co2Quanteec:[],
        energySavingQuanteec: [],
        energyNumberLength: 0,
        energyNormalConnected: [],
        energyQuanteecConnected: [],
        energyDevicesConnected: [],
        co2NormalConnected: [],
        co2QuanteecConnected:[],
        energySavingQuanteecConnected: [],
        energyNumberLengthConnected: 0,
        waterConsumed: [],
        waterConsumedQuanteec: [],


        /***IEA */
        energyNormalIEA: [],
        energyQuanteecIEA: [],
        energyDevicesIEA: [],
        energySavedIEA: [],
        co2NormalIEA: [],
        co2QuanteecIEA:[],
        energySavingQuanteecIEA: [],
        energyNormalIEAConnected: [],
        energyQuanteecIEAConnected: [],
        energyDevicesIEAConnected: [],
        co2NormalIEAConnected: [],
        co2QuanteecIEAConnected:[],
        energySavingQuanteecIEAConnected: [],
        waterConsumedIEA: [],
        waterConsumedQuanteecIEA: [],


         /***SHIFT */
        energyNormalSHIFT: [],
        energyQuanteecSHIFT: [],
        energyDevicesSHIFT: [],
        energySavedSHIFT: [],
        co2NormalSHIFT: [],
        co2QuanteecSHIFT:[],
        energySavingQuanteecSHIFT: [],
        energyNormalSHIFTConnected: [],
        energyQuanteecSHIFTConnected: [],
        energyDevicesSHIFTConnected: [],
        co2NormalSHIFTConnected: [],
        co2QuanteecSHIFTConnected:[],
        energySavingQuanteecSHIFTConnected: [],
        waterConsumedSHIFT:[],
        waterConsumedQuanteecSHIFT:[],

        /***Dimpact */
        energyNormalDimpact: [],
        energyQuanteecDimpact: [],
        energyDevicesDimpact: [],
        energySavedDimpact: [],
        co2NormalDimpact: [],
        co2QuanteecDimpact:[],
        energySavingQuanteecDimpact: [],
        energyNormalDimpactConnected: [],
        energyQuanteecDimpactConnected: [],
        energyDevicesDimpactConnected: [],
        co2NormalDimpactConnected: [],
        co2QuanteecDimpactConnected:[],
        energySavingQuanteecDimpactConnected: [],
        waterConsumedDimpact:[],
        waterConsumedQuanteecDimpact:[],


        geoCDN: [],
        geoPlugin: [],
        MB_peer_city:[],
        MB_peer_region:[],
        MB_peer_country:[],
        MB_peer_ip:[],
        networkWifiDataConnected : [],
        networkCellularDataConnected : [],
        devicePhoneDataConnected : [],
        deviceTabletDataConnected : [],
        deviceComputerDataConnected : [],
        MB_peer_cityConnected : [],
        MB_peer_regionConnected : [],
        MB_peer_countryConnected : [],
        MB_peer_ipConnected : [],

        // Total
        totalMB_peer: 0,
        totalMB_server: 0,
        totalMB: 0,
        totalMB_peer_connected: 0,
        totalMB_server_connected: 0,
        totalMB_connected: 0,
        totalsec_peer: 0,
        totalsec_server: 0,
        totalViewingTime: 0,
        totalViewingTimeMobile: 0,
        totalViewingTimeTablet: 0,
        totalViewingTimeDesktop: 0,
        totalViewingTimeWifi: 0,
        totalViewingTimeCellular: 0,

        totalRebufMin: 0,
        totalViews: 0,
        concurrentViews: 0,
        concurrentViews2: 0,
        connectedViews: 0,

        totalEnergy: 0,
        totalEnergyIEA: 0,
        totalEnergySHIFT: 0,
        totalEnergyDimpact: 0,
        totalEnergyDevices: 0,
        totalEnergyDevicesIEA: 0,
        totalEnergyDevicesSHIFT: 0,
        totalEnergyDevicesDimpact: 0,
        totalEnergySaved: 0,
        totalEnergySavedIEA: 0,
        totalEnergySavedSHIFT: 0,
        totalLightsSavedSHIFT:0,
        totalEnergySavedDimpact: 0,
        totalLightsSavedDimpact:0,
        totalLightsSavedIEA:0,
        totalLightsSaved:0,
        totalHouseSaved:0,
        totalCo2: 0,
        totalCo2Saved: 0,
        totalKmSaved: 0,
        totalCo2IEA: 0,
        totalCo2SavedIEA: 0,
        totalKmSavedIEA: 0,
        totalCo2SHIFT: 0,
        totalCo2SavedSHIFT: 0,
        totalKmSavedSHIFT: 0,
        totalCo2Dimpact: 0,
        totalCo2SavedDimpact: 0,
        totalKmSavedDimpact: 0,
        totalEnergySaving: 0,
        totalEnergySavingConnected: 0,
        totalEnergySavingIEA: 0,
        totalEnergySavingConnectedIEA: 0,
        totalEnergySavingSHIFT: 0,
        totalEnergySavingConnectedSHIFT: 0,
        totalEnergySavingDimpact: 0,
        totalEnergySavingConnectedDimpact: 0,
        totalWater: 0,
        totalWaterSaved: 0,
        totalWaterIEA: 0,
        totalWaterSavedIEA: 0,
        totalWaterSHIFT: 0,
        totalWaterSavedSHIFT: 0,
        totalWaterDimpact: 0,
        totalWaterSavedDimpact: 0,

        totalBestQuality: 0,
        totalOtherQualities: 0,

        // Mixed Data
        nbrRequests: 0,
        currNbrRequests:0,
        isLoading: false,

        // Charts
        chartViewingTimeNetworkLoaded: false,
        chartViewingTimeNetworkdata: {
            labels: [],
            datasets: [{
                label: 'View. time - other nets',
                data: [],
                backgroundColor: '#aac8d4',
            },
            {
                label: 'View. time - cell nets',
                data: [],
                backgroundColor: 'rgb(20, 191, 152)'
            }],
        },
        chartViewingTimeDeviceLoaded: false,
        chartViewingTimeDevicedata: {
            labels: [],
            datasets: [{
                label: 'View. time - others',
                data: [],
                backgroundColor: '#aac8d4',
                
            },
            {
                label: 'View. time - tablet',
                data: [],
                backgroundColor: '#2a5d77'
            },
            {
                label: 'View. time - mobile',
                data: [],
                backgroundColor: 'rgb(20, 191, 152)'
            }]
        },
        chartMBLoaded: false,
        chartMBdata: {
            labels: [],
            datasets: [{
                label: 'Data from CDN',
                data: [],
                backgroundColor: '#aac8d4',
            },{
                label: 'Data from viewers',
                data: [],
                backgroundColor: '#2a5d77'
            }]
        },
        chartViewsLoaded: false,
        chartViewsdata: {
            labels: [],
            datasets: [{
                label: 'Playing sessions',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 1)',
                borderColor: 'rgb(21, 62, 82)'
            }]
        },
        chartViewingTimeLoaded: false,
        chartViewingTimedata: {
            labels: [],
            datasets: [{
                label: 'View. time - from CDN',
                data: [],
                backgroundColor: '#aac8d4',
                
            },{
                label: 'View. time - from viewers',
                data: [],
                backgroundColor: '#2a5d77'
            }]
        },
        chartRebufLoaded: false,
        chartRebufdata: {
            labels: [],
            datasets: [{
                label: 'Rebuffered seconds',
                data: [],
                backgroundColor: '#ba0000',
                yAxisID: 'A',
                order: 2
            },{
                label: 'Played seconds',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.6)',
                borderColor: '#2F90B0',
                yAxisID: 'A',
                order: 2
            },{
                label: 'Rebuffering %',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                type: 'line',
                yAxisID: 'B',
                order: 1,
                borderWidth: 1.5,
                pointRadius: 0.8   
            }]
        },
        chartQualitiesLoaded: false,
        chartQualitiesdata: {
            labels: [],
            datasets: [{
                label: 'SD',
                data: [],
                backgroundColor: 'rgba(255, 0, 0, 0.6)',
                borderColor: '#ba0000',
            },{
                label: 'HD',
                data: [],
                backgroundColor: 'rgba(186, 0, 143, 0.6)',
                borderColor: '#ba008f',
            },
            {
                label: 'Full HD 1080p',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.6)',
                borderColor: '#2F90B0',
            },
            {
                label: '2K 1440p',
                data: [],
                backgroundColor: '#aac8d4',
                borderColor: '#aac8d4',
            },
            {
                label: '4K 2160p',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
            }]
            /*
            {
                label: '8K',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.6)',
                borderColor: 'rgb(21, 62, 82)',
            }
            */
        },
        chartPercentQualityLoaded: false,
        chartPercentQualitydata: {
            labels: [],
            datasets: [
            {
                label: 'High qualities %',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                type: 'line',
                borderWidth: 1.5,
                pointRadius: 0.8 
            }]
        },
        chartBitrateLoaded: false,
        chartBitratedata: {
            labels: [],
            datasets: [{
                label: 'Average bitrate',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8 
            }]
        },
        chartMeanViewingTimeLoaded: false,
        chartMeanViewingTimedata: {
            labels: [],
            datasets: [{
                label: 'Mean viewing time per session',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: 'rgb(21, 62, 82)'
            }]
        },
        chartConcurrentViewsLoaded: false,
        chartConcurrentViewsdata: {
            labels: [],
            datasets: [{
                label: 'Concurrent viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                //backgroundColor: 'rgba(170, 200, 212, 0.6)',
                //borderColor: 'rgb(170, 200, 212)',
                borderWidth: 1.5,
                pointRadius: 0.8 
            },
            {
                label: 'Concurrent viewers - conn. viewers',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                //backgroundColor: 'rgba(21, 62, 82, 0.6)',
                //borderColor: 'rgb(21, 62, 82)',
                borderWidth: 1.5,
                pointRadius: 0.8 
            }
            ]
        },
        chartOffloadLoaded: false,
        chartOffloaddata: {
            labels: [],
            datasets: [{
                label: 'Efficiency %',
                data: [],
                backgroundColor: 'rgba(42, 93, 119, 0.4)',
                borderColor: 'rgb(42, 93, 119)',
                borderWidth: 1.5, 
                pointRadius: 0.8
            },
            {
                label: 'Efficiency % - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5, 
                pointRadius: 0.8
            }]
        },
        chartEnergyLoaded: false,
        chartEnergydata: {
            labels: [],
            datasets: [{
                label: 'Energy consumed by viewing',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0)',
                borderColor: 'red',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },{
                label: 'Energy consumed by delivery with QUANTEEC',
                data: [],
                backgroundColor: 'rgba(43, 126, 167, 0.4)',
                borderColor: '#1e5875',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },
            {
                label: 'Energy saved by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }]
        },
        chartCo2Loaded: false,
        chartCo2data: {
            labels: [],
            datasets: [{
                label: 'CO2 produced w/o QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 produced by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartEnergyLoadedIEA: false,
        chartEnergydataIEA: {
            labels: [],
            datasets: [{
                label: 'Energy consumed by devices (IEA)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },{
                label: 'Energy consumed by delivery with QUANTEEC (IEA)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },
            {
                label: 'Energy saved by QUANTEEC (IEA)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }]
        },
        chartCo2LoadedIEA: false,
        chartCo2dataIEA: {
            labels: [],
            datasets: [{
                label: 'CO2 produced w/o QUANTEEC (IEA)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 produced by QUANTEEC (IEA)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartEnergyLoadedSHIFT: false,
        chartEnergydataSHIFT: {
            labels: [],
            datasets: [{
                label: 'Energy consumed by devices (SHIFT)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },{
                label: 'Energy consumed by delivery with QUANTEEC (SHIFT)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },
            {
                label: 'Energy saved by QUANTEEC (SHIFT)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }]
        },
        chartCo2LoadedSHIFT: false,
        chartCo2dataSHIFT: {
            labels: [],
            datasets: [{
                label: 'CO2 produced w/o QUANTEEC (SHIFT)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 produced by QUANTEEC (SHIFT)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartEnergyLoadedDimpact: false,
        chartEnergydataDimpact: {
            labels: [],
            datasets: [{
                label: 'Energy consumed by devices (Dimpact)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            },{
                label: 'Energy consumed by delivery with QUANTEEC (Dimpact)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },
            {
                label: 'Energy saved by QUANTEEC (Dimpact)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 3
            }]
        },
        chartCo2LoadedDimpact: false,
        chartCo2dataDimpact: {
            labels: [],
            datasets: [{
                label: 'CO2 produced w/o QUANTEEC (DImpact)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'CO2 produced by QUANTEEC (DImpact)',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartEnergySavingLoaded: false,
        chartEnergySavingdata: {
            labels: [],
            datasets: [{
                label: 'Energy saved %',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8 
            },
            {
                label: 'Energy saved % - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },
        chartEnergySavingLoadedIEA: false,
        chartEnergySavingdataIEA: {
            labels: [],
            datasets: [{
                label: 'Energy saved % (IEA)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8
            },
            {
                label: 'Energy saved % (IEA) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },        
        chartEnergySavingLoadedSHIFT: false,
        chartEnergySavingdataSHIFT: {
            labels: [],
            datasets: [{
                label: 'Energy saved % (SHIFT)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8
            },
            {
                label: 'Energy saved % (SHIFT) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },
        chartEnergySavingLoadedDimpact: false,
        chartEnergySavingdataDimpact: {
            labels: [],
            datasets: [{
                label: 'Energy saved % (DImpact)',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.4)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8
            },
            {
                label: 'Energy saved % (DImpact) - conn. viewers',
                data: [],
                backgroundColor: 'rgba(47, 144, 176, 0.4)',
                borderColor: '#2F90B0',
                borderWidth: 1.5,
                pointRadius: 0.8
            }]
        },
        chartWaterLoaded: false,
        chartWaterdata: {
            labels: [],
            datasets: [{
                label: 'Water consumed w/o QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartWaterLoadedIEA: false,
        chartWaterdataIEA: {
            labels: [],
            datasets: [{
                label: 'Water consumed w/o QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartWaterLoadedSHIFT: false,
        chartWaterdataSHIFT: {
            labels: [],
            datasets: [{
                label: 'Water consumed w/o QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },
        chartWaterLoadedDimpact: false,
        chartWaterdataDimpact: {
            labels: [],
            datasets: [{
                label: 'Water consumed w/o QUANTEEC',
                data: [],
                backgroundColor: 'rgba(20, 191, 152, 0.6)',
                borderColor: 'rgb(20, 191, 152)',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 2
            },{
                label: 'Water consumed by QUANTEEC',
                data: [],
                backgroundColor: 'rgba(21, 62, 82, 0.4)',
                borderColor: '#153e52',
                borderWidth: 1.5,
                pointRadius: 0.8,
                order: 1
            }]
        },

        // LOADER
        isGetInProgress: false,
        timeoutSearch: null,
        timeoutSearchDuration: 2,
        oldSearch:"",


        //VIDEO MODAL
        videos:[],
        selectedVideos:[],
        selectedVideosTmp:[],
        videoPage : 1,
        videoPageSize:12,
        searchBar : "",
        totalPages:0,
        type:"",
        videosPlugin:[],
    }
  },
  computed: {
      totalCo2Saved_computed() {
        let label = '';
        let value = this.totalCo2Saved;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
        totalCo2Saved_computedIEA() {
        let label = '';
        let value = this.totalCo2SavedIEA;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
        totalCo2Saved_computedSHIFT() {
        let label = '';
        let value = this.totalCo2SavedSHIFT;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
        totalCo2Saved_computedDimpact() {
        let label = '';
        let value = this.totalCo2SavedDimpact;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalCo2_computed() {
        let label = '';
        let value = this.totalCo2;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },      
      totalCo2_computedIEA() {
        let label = '';
        let value = this.totalCo2IEA;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },      
      totalCo2_computedSHIFT() {
        let label = '';
        let value = this.totalCo2SHIFT;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalCo2_computedDimpact() {
        let label = '';
        let value = this.totalCo2Dimpact;
        let unit = 'mg';
        if (value > 1000000) {
            unit = 'kg';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'g';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },      
      totalWaterSaved_computed() {
        let label = '';
        let value = this.totalWaterSaved;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
        totalWaterSaved_computedIEA() {
        let label = '';
        let value = this.totalWaterSavedIEA;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
        totalWaterSaved_computedSHIFT() {
        let label = '';
        let value = this.totalWaterSavedSHIFT;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
        totalWaterSaved_computedDimpact() {
        let label = '';
        let value = this.totalWaterSavedDimpact;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalWater_computed() {
        let label = '';
        let value = this.totalWater;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },      
      totalWater_computedIEA() {
        let label = '';
        let value = this.totalWaterIEA;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },      
      totalWater_computedSHIFT() {
        let label = '';
        let value = this.totalWaterSHIFT;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalWater_computedDimpact() {
        let label = '';
        let value = this.totalWaterDimpact;
        let unit = 'ml';
        if (value > 1000000) {
            unit = 'm³';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'l';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },

      totalEnergySaved_computed() {
        let label = '';
        let value = this.totalEnergySaved;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },      
      totalEnergySaved_computedIEA() {
        let label = '';
        let value = this.totalEnergySavedIEA;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },      
      totalEnergySaved_computedSHIFT() {
        let label = '';
        let value = this.totalEnergySavedSHIFT;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergySaved_computedDimpact() {
        let label = '';
        let value = this.totalEnergySavedDimpact;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergy_computed() {
        let label = '';
        let value = this.totalEnergy;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergy_computedIEA() {
        let label = '';
        let value = this.totalEnergyIEA;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergy_computedSHIFT() {
        let label = '';
        let value = this.totalEnergySHIFT;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergy_computedDimpact() {
        let label = '';
        let value = this.totalEnergyDimpact;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergyDevices_computed() {
        let label = '';
        let value = this.totalEnergyDevices;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergyDevices_computedIEA() {
        let label = '';
        let value = this.totalEnergyDevicesIEA;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergyDevices_computedSHIFT() {
        let label = '';
        let value = this.totalEnergyDevicesSHIFT;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalEnergyDevices_computedDimpact() {
        let label = '';
        let value = this.totalEnergyDevicesDimpact;
        let unit = 'mWh';
        if (value > 1000000000000000) {
            unit = 'TWh';
            value = Math.round(value / 1000000000000000 * 10) / 10
        } else if (value > 1000000000000) {
            unit = 'GWh';
            value = Math.round(value / 1000000000000 * 10) / 10
        } else if (value > 1000000000) {
            unit = 'MWh';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'kWh';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'Wh';
            value = Math.round(value / 1000 * 10) / 10
        } else {
            value = Math.round(value * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalViewingTime_computed() {
        let label = '';
        let value = this.totalViewingTime;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalViewingTimeWifi_computed() {
        let label = '';
        let value = this.totalViewingTimeWifi;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalViewingTimeCellular_computed() {
        let label = '';
        let value = this.totalViewingTimeCellular;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalViewingTimeMobile_computed() {
        let label = '';
        let value = this.totalViewingTimeMobile;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalViewingTimeTablet_computed() {
        let label = '';
        let value = this.totalViewingTimeTablet;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalViewingTimeDesktop_computed() {
        let label = '';
        let value = this.totalViewingTimeDesktop;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalsec_peer_computed() {
        let label = '';
        let value = this.totalsec_peer;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalsec_server_computed() {
        let label = '';
        let value = this.totalsec_server;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
        } else if (value < 3600) {
            label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalRebufMin_computed() {
        let label = '';
        let value = this.totalRebufMin;
        if (value >= 3600) {
            label = `${Math.round(value/3600)}h ${Math.round((value%60))}s`;
        }
        return label;
      },
      totalBestQuality_computed() {
        let label = '';
        let value = this.totalMaxQuality;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalOtherQualities_computed() {
        let label = '';
        let value = this.totalOtherQualities;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalSD_computed() {
        let label = '';
        let value = this.totalSD;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalHD_computed() {
        let label = '';
        let value = this.totalHD;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalFullHD_computed() {
        let label = '';
        let value = this.totalFullHD;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      total2K_computed() {
        let label = '';
        let value = this.total2K;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      total4K_computed() {
        let label = '';
        let value = this.total4K;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      total8K_computed() {
        let label = '';
        let value = this.total8K;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalMB_peer_computed() {
        let label = '';
        let value = this.totalMB_peer;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalMB_server_computed() {
        let label = '';
        let value = this.totalMB_server;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      totalMB_computed() {
        let label = '';
        let value = this.totalMB;
        let unit = 'kB';
        if (value > 1000000000) {
            unit = 'TB';
            value = Math.round(value / 1000000000 * 10) / 10
        } else if (value > 1000000) {
            unit = 'GB';
            value = Math.round(value / 1000000 * 10) / 10
        } else if (value > 1000) {
            unit = 'MB';
            value = Math.round(value / 1000 * 10) / 10
        }
        label += value + ' ' + unit;
        return label;
      },
      averageBitrate() {
          if (this.totalViewingTime !== 0) {
            let value = Math.round(8 * (this.totalMB / this.totalViewingTime));
            let result = '';
            let unit = 'kb/s'
            if (value > 1000) {
                unit = "Mb/s"
                value = Math.round(value / 1000 * 10) / 10;
            } else {
                value = Math.round(value * 10) / 10;
            }
            result += value + ' ' + unit;
            return result;
          } else {
            return '0 kb/s';
          }
      },
      meanViewingTime() {
          if (this.concurrentViews > 0) {
            let label = '';
            let value = Math.round((this.totalViewingTime) / this.concurrentViews)            
            if (value >= 3600) {
                label = `${Math.round(value/3600)}h ${Math.round((value%3600)/60)}min`;
            } else if (value < 3600) {
                label = `${Math.round(value/60)}min ${Math.round((value%60))}s`;
            }
            return label;
          } else {
            return '0s';
          }
      },
      viewerRetention() {
          if (this.totalViews > 0) {
            let value = Math.round((this.totalViewingTime / this.totalViews) / (this.intervalOptions.find(x => x.value === this.interval)['tenSeconds'] * 10) * 100)
            if (value === 0) {
                value = Math.round((this.totalViewingTime / this.totalViews) / (this.intervalOptions.find(x => x.value === this.interval)['tenSeconds'] * 10) * 10000) / 100
            }
            let result = '';
            result += value + '%'
            return result;
          } else {
            return '0%';
          }
      },
      totalRebuf() {
          if (this.sec_rebuf.length > 0 && this.sec_server.length > 0 && this.sec_peer.length > 0) {
            let sum = this.totalViewingTime + this.totalRebufMin;
            if (sum > 0) {
                let value = this.totalRebufMin / sum;
                let result = Math.round(value * 10000) / 100;
                return result + '%'
            } else {
                return 'No Data';
            }
          } else {
            return 'No Data';
          }
      },
      totalOffload() {
          if (this.totalMB > 0) {
            let value = this.totalMB_peer / this.totalMB
            let result = Math.round( value * 10000) / 100;
            return Math.round(result) + '%'
          } else {
            return 'No Data';
          }
      },
      totalOffloadConnected() {
          if (this.totalMB > 0) {
            let value = this.totalMB_peer_connected / this.totalMB_connected
            let result = Math.round( value * 10000) / 100;
            return Math.round(result) + '%'
          } else {
            return 'No Data';
          }
      },
      totalOffloadTime() {
        if (this.totalViewingTime > 0) {
            let value = this.totalsec_peer / this.totalViewingTime
            let result = Math.round( value * 10000) / 100;
            return Math.round(result) + '%'
          } else {
            return 'No Data';
          }
      },
      quality_computed() {
          if (this.totalMaxQuality + this.totalOtherQualities > 0) {
            let value = this.totalMaxQuality / (this.totalMaxQuality + this.totalOtherQualities);
            let result = Math.round( value * 10000) / 100;
            return Math.round(result) + '%'
          } else {
            return 'No Data';
          }
      },
  },
  mounted: function() {
      this.getPluginVideosList()
      this.filter = (this.video && this.video.authorizationKey && this.video.authorizationKey.indexOf('cam') > -1) ? this.video.authorizationKey : this.video.uuid;
      this.key = this.clientView;
      
      this.type = this.$auth.getMyUser().client_infos[0].type
      let initialVideo = this.$route.query.video;

      if (initialVideo) {
          /*this.selectVideoPlugin({videoID: initialVideo});
          this.loadSelectedVideos();*/
          this.filter = initialVideo;
      }

      this.loadData();

      window.onbeforeprint = (ev) => {
        for (var id in Chart.instances) {
            let instance = Chart.instances[id];
            instance.oldStyle = {
                width: instance.canvas.style.width,
                height: instance.canvas.style.height
            };
            instance.canvas.style.width = '100%';
            instance.canvas.style.height = '300px';

        }
    };

    window.onafterprint = (ev) => {
        for (var id in Chart.instances) {
            let instance = Chart.instances[id];
            instance.canvas.style.width = instance.oldStyle.width;
            instance.canvas.style.height = instance.oldStyle.height;
            delete instance.oldStyle;
        }
    };
  },
  methods: {
    downloadCSV() {
        var csvContent = 'sep=,\nDate (ms since epoch), Best quality (%), Data best quality (kB), Data other qualities (kB), Average video bitrate (kb/s), Rebuffering (%), '
        csvContent += 'Efficiency (%), Data from CDN (kB), Data from viewers (kB), Video duration from CDN (s), Video duration from viewers (s), '
        csvContent += 'Energy needed (kWh), Energy used by QUANTEEC (kWh), Co2 delivered in current systems (g), Co2 delivered with QUANTEEC, Energy savings (%), '
        csvContent += 'Total number of views, Mean viewing time per session (s)\n';

        for (let i = 0; i < this.chartMBdata.datasets[0].data.length; i++) {
            csvContent += this.chartMBdata.datasets[0].data[i].x.getTime();
            csvContent += ', ';
            // Quality
            csvContent += (this.chartPercentQualitydata.datasets[0].data[i]) ? this.chartPercentQualitydata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartQualitiesdata.datasets[2].data[i]) ? Math.round(this.chartQualitiesdata.datasets[2].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartQualitiesdata.datasets[0].data[i] && this.chartQualitiesdata.datasets[1].data[i]) ? Math.round(this.chartQualitiesdata.datasets[0].data[i].y + this.chartQualitiesdata.datasets[1].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartBitratedata.datasets[0].data[i]) ? this.chartBitratedata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartRebufdata.datasets[2].data[i]) ? this.chartRebufdata.datasets[2].data[i].y : 0;
            csvContent += ', ';
            //Efficiency
            csvContent += (this.chartOffloaddata.datasets[0].data[i]) ? this.chartOffloaddata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartMBdata.datasets[0].data[i]) ? Math.round(this.chartMBdata.datasets[0].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartMBdata.datasets[1].data[i]) ? Math.round(this.chartMBdata.datasets[1].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartViewingTimedata.datasets[0].data[i]) ? Math.round(this.chartViewingTimedata.datasets[0].data[i].y) : 0;
            csvContent += ', ';
            csvContent += (this.chartViewingTimedata.datasets[1].data[i]) ? Math.round(this.chartViewingTimedata.datasets[1].data[i].y) : 0;
            csvContent += ', ';
            // Energy
            csvContent += (this.chartEnergydata.datasets[0].data[i]) ? this.chartEnergydata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergydata.datasets[1].data[i]) ? this.chartEnergydata.datasets[1].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2data.datasets[0].data[i]) ? this.chartCo2data.datasets[0].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartCo2data.datasets[1].data[i]) ? this.chartCo2data.datasets[1].data[i].y : 0;
            csvContent += ', ';
            csvContent += (this.chartEnergySavingdata.datasets[0].data[i]) ? this.chartEnergySavingdata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            // Views
            csvContent += (this.chartViewsdata.datasets[0].data[i]) ? this.chartViewsdata.datasets[0].data[i].y : 0;
            csvContent += ', ';
            if (this.meanViewingTimeLoaded) {
                console.log('[CSV] chartMeanViewingTimedata error');
                csvContent += this.chartMeanViewingTimedata.datasets[0].data[i].y;
            } else {
                csvContent += 0;
            }
            csvContent += '\n';

        }

        var download = function(content, fileName, mimeType) {
        var a = document.createElement('a');
        mimeType = mimeType || 'application/octet-stream';

        if (navigator.msSaveBlob) { // IE10
            navigator.msSaveBlob(new Blob([content], {
            type: mimeType
            }), fileName);
        } else if (URL && 'download' in a) { //html5 A[download]
            a.href = URL.createObjectURL(new Blob([content], {
            type: mimeType
            }));
            a.setAttribute('download', fileName);
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } else {
            location.href = 'data:application/octet-stream,' + encodeURIComponent(content); // only this mime type is supported
        }
        }

        download(csvContent, `quanteec_analytics_${new Date().toISOString()}.csv`, 'text/csv;encoding:utf-8');
    },
    downloadPDF() {
        // Open the print window
        window.print();


    },
    classicDate() {
        let number = +this.dateLabel.substring(0, this.dateLabel.length - 1);
        let unit = this.dateLabel[this.dateLabel.length - 1];
//      this.range = {};
        let end = new Date();
        let start = null;

        if (unit === 'h') {
            start = new Date(end.getFullYear(), end.getMonth(), end.getDate(), end.getHours() - number, 0, 0);
            this.range = {
                start: start,
                end: end,
            }
        }
        else if (unit === 'd') {
            start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - number, end.getHours(), 0, 0);
            this.range = {
                start: start,
                end: end,
            }
        }
        this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm:ss");
        this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm:ss");
    },
    adjustDate() {
        /*this.range.end = new Date(1646057700000);
        this.range.start = new Date(1646055900000);*/
        this.dateEnd = moment(this.range.end).format("DD/MM/YY @HH:mm:ss");
        this.dateStart = moment(this.range.start).format("DD/MM/YY @HH:mm:ss");
    },
    manageRequestsLoaded() {
        this.currNbrRequests++;
        if (this.currNbrRequests >= this.nbrRequests) {
            this.isLoading = false;
        }
    },
    cleanCharts() {
        // Quality
        this.chartQualitiesdata.datasets[0].data = [];
        this.chartQualitiesdata.datasets[1].data = [];
        this.chartQualitiesdata.datasets[2].data = [];

        this.chartPercentQualitydata.datasets[0].data = [];

        this.chartBitratedata.datasets[0].data = [];

        this.chartRebufdata.datasets[0].data = [];
        this.chartRebufdata.datasets[1].data = [];
        this.chartRebufdata.datasets[2].data = [];

        this.chartViewingTimeDevicedata.datasets[2].data = [];
        this.chartViewingTimeDevicedata.datasets[1].data = [];
        this.chartViewingTimeDevicedata.datasets[0].data = [];
        this.chartViewingTimeNetworkdata.datasets[1].data = [];
        this.chartViewingTimeNetworkdata.datasets[0].data = [];

        // Efficiency
        this.chartOffloaddata.datasets[0].data = [];

        this.chartMBdata.datasets[0].data = [];
        this.chartMBdata.datasets[1].data = [];

        this.chartViewingTimedata.datasets[0].data = [];
        this.chartViewingTimedata.datasets[1].data = [];

        // Energy
        this.chartEnergydata.datasets[0].data = [];
        this.chartEnergydata.datasets[1].data = [];
        this.chartEnergydata.datasets[2].data = [];
        this.chartCo2data.datasets[0].data = [];
        this.chartCo2data.datasets[1].data = [];
        this.chartEnergySavingdata.datasets[0].data = [];
        this.chartEnergySavingdata.datasets[1].data = [];

        this.chartEnergydataIEA.datasets[0].data = [];
        this.chartEnergydataIEA.datasets[1].data = [];
        this.chartEnergydataIEA.datasets[2].data = [];
        this.chartCo2dataIEA.datasets[0].data = [];
        this.chartCo2dataIEA.datasets[1].data = [];
        this.chartEnergySavingdataIEA.datasets[0].data = [];
        this.chartEnergySavingdataIEA.datasets[1].data = [];

        this.chartEnergydataSHIFT.datasets[0].data = [];
        this.chartEnergydataSHIFT.datasets[1].data = [];
        this.chartEnergydataSHIFT.datasets[2].data = [];
        this.chartCo2dataSHIFT.datasets[0].data = [];
        this.chartCo2dataSHIFT.datasets[1].data = [];
        this.chartEnergySavingdataSHIFT.datasets[0].data = [];
        this.chartEnergySavingdataSHIFT.datasets[1].data = [];

        this.chartEnergydataDimpact.datasets[0].data = [];
        this.chartEnergydataDimpact.datasets[1].data = [];
        this.chartEnergydataDimpact.datasets[2].data = [];
        this.chartCo2dataDimpact.datasets[0].data = [];
        this.chartCo2dataDimpact.datasets[1].data = [];
        this.chartEnergySavingdataDimpact.datasets[0].data = [];
        this.chartEnergySavingdataDimpact.datasets[1].data = [];

        // Views
        this.chartViewsdata.datasets[0].data = [];
        this.chartMeanViewingTimedata.datasets[0].data = [];
        this.chartConcurrentViewsdata.datasets[0].data = [];
        this.chartConcurrentViewsdata.datasets[1].data = [];
    },
    autoAdaptInterval() {
        let scale = Math.round((this.range.end.getTime() - this.range.start.getTime()) / 1000) ;
        if (scale <= 4 * 60 * 60 && this.timeRangeType) {
                this.interval = '10m'//'1m' 
        } else if (scale <= 25 * 60 * 60 && this.timeRangeType) {
                this.interval = '10m'//'5m' 
        } else if (scale <= 2 * 25 * 60 * 60) {
                this.interval = '10m' 
        } else if (scale <= 5 * 25 * 60 * 60) {
                this.interval = '30m' 
        } else if (scale <= 7 * 25 * 60 * 60) {
                this.interval = '1h' 
        } else if (scale <= 14 * 25 * 60 * 60) {
                this.interval = '3h' 
        } else if (scale <= 30 * 25 * 60 * 60) {
                this.interval = '6h' 
        } else if (scale <= 2 * 30 * 25 * 60 * 60) {
                this.interval = '1d' 
        } else {
                this.interval = Math.ceil((scale /  (30 * 25 * 60 * 60)) - 2) + 'd'
        }

        this.intervalOptions[0].text = `Auto (${this.interval})`
        if (this.intervalDisplayed !== 'auto') {
            this.interval = this.intervalDisplayed;
        }
        let toDisable = [];
        if (scale > 2 * 30 * 24 * 60 * 60) {
            toDisable = ['6h','3h', '1h','30m', '10m', '5m', '1m'];
        } else if (scale > 2 * 30 * 24 * 60 * 60) {
            toDisable = ['3h', '1h','30m', '10m', '5m', '1m'];
        } else if (scale > 30 * 24 * 60 * 60) {
            toDisable = ['30m', '10m', '5m', '1m'];
        } else if (scale > 14 * 24 * 60 * 60) {
            toDisable = ['30', '10m', '5m', '1m'];
        } else if (scale > 7 * 24 * 60 * 60) {
            toDisable = ['10m', '5m', '1m'];
        } else if (scale > 4 * 24 * 60 * 60 || true) {
            toDisable = ['5m', '1m'];
        } else if (scale > 2 * 24 * 60 * 60) {
            toDisable = ['1m'];
        }
        let changeInterval = false;
        for (let idx in this.intervalOptions) {
            let option = this.intervalOptions[idx];
            if (toDisable.indexOf(option.value) > -1) {
                option.disabled = true;
                if (this.interval === option.value) {
                    changeInterval = true;
                }
            } else {
                if (changeInterval) {
                    changeInterval = false;
                    this.interval = option.value;
                    this.intervalDisplayed = option.value;
                }
                option.disabled = false;
            }
        }

    },
    displayMarker()
    {
        this.markersCDN = [];

        if(this.geoCDN.length>0)
        {
            this.geoCDN.forEach(geo => {
                let marker = {
                    coordinates:L.latLng(geo.Latitude, geo.Longitude),
                    description:geo.Name + " " + geo._sumData
                }
                this.markersCDN.push(marker)
            })
        } else if (this.geoPlugin.length > 0)
        {
            if(this.countryCode === undefined)
            {
                this.countryCode = this.countryDataRaw.reduce(function(map, obj){
                    map[obj.country] = obj;
                    return map;
                }, {});
            }

            this.geoPlugin.forEach(geo=>{
            let data = this.countryCode[geo.key]

            let valueServer = geo.MB_server.value;
            let unitServer = 'kB';
            if (valueServer > 1000000000) {
                unitServer = 'TB';
                valueServer = Math.round(valueServer / 1000000000 * 10) / 10
            } else if (valueServer > 1000000) {
                unitServer = 'GB';
                valueServer = Math.round(valueServer / 1000000 * 10) / 10
            } else if (valueServer > 1000) {
                unitServer = 'MB';
                valueServer = Math.round(valueServer / 1000 * 10) / 10
            }

            let valuePeer = geo.MB_peer.value;
            let unitPeer = 'kB';
            if (valuePeer > 1000000000) {
                unitPeer = 'TB';
                valuePeer = Math.round(valuePeer / 1000000000 * 10) / 10
            } else if (valuePeer > 1000000) {
                unitPeer = 'GB';
                valuePeer = Math.round(valuePeer / 1000000 * 10) / 10
            } else if (valuePeer > 1000) {
                unitPeer = 'MB';
                valuePeer = Math.round(valuePeer / 1000 * 10) / 10
            }



                let marker = {
                    coordinates:L.latLng(data.latitude, data.longitude),
                    description:`${data.name}<br>
                        Data from CDN : ${valueServer} ${unitServer} <br>
                        Data from viewers : ${valuePeer} ${unitPeer}`
                }

                this.markersCDN.push(marker)
            })
        }
        
    },
    loadData() {  
        this.calendarValidate = false;
        try {
            clearTimeout(this.timeoutSearch);
        } catch (e) {}
        this.oldSearch = this.search;

        if (!this.timeRangeType) {
            this.classicDate();
        } else {
            this.adjustDate();
        }
        this.autoAdaptInterval();
        this.isLoading = true;
        this.nbrRequests = 10;
        this.currNbrRequests = 0;

        this.chartRebufLoaded = false;
        this.chartMeanViewingTimeLoaded = false;
        this.chartEnergyLoaded = false;
        this.chartCo2Loaded = false;
        this.chartEnergyLoadedIEA = false;
        this.chartCo2LoadedIEA = false;
        this.chartEnergyLoadedSHIFT = false;
        this.chartCo2LoadedSHIFT = false;
        this.chartEnergyLoadedDimpact = false;
        this.chartCo2LoadedDimpact = false;    
        this.chartEnergySavingLoaded = false;
        this.chartEnergySavingLoadedIEA = false;
        this.chartEnergySavingLoadedSHIFT = false;
        this.chartEnergySavingLoadedDimpact = false;
        this.chartViewingTimeDeviceLoaded = false;
        this.chartViewingTimeNetworkLoaded = false;

        this.cleanCharts();

        this.load_geodata().then(() => {
            this.manageRequestsLoaded();
            this.displayMarker();
        }).catch((err) => {
            this.manageRequestsLoaded();
            console.log("geo data -", err);
        });

        this.load_geodata_plugin().then(()=>{
            console.log("here")
            this.displayMarker();
        }).catch(err=>{
            console.log("geo data plugin -", err)
        })
        
        
        /*this.loadEnergyData().then(() => {
            this.manageRequestsLoaded()
        }).catch((err) => {
            console.log("Energy -", err);
            this.manageRequestsLoaded()
        });*/                      
        // MB_peer, MB_server, sec_peer, sec_server
        this.loadMB_Sec().then(() => {
            this.manageRequestsLoaded()
            this.loadMB_Sec_Connected().then(() => {
                this.manageRequestsLoaded()
                this.loadEnergy().then(() => {
                    this.manageRequestsLoaded()
                    /*this.loadEnergyConnected().then(()=>{
                        this.loadEnergyData().then(() => {
                            this.loadEnergyDataConnected().then(()=>{
                                this.manageRequestsLoaded()
                            }).catch((err) => {
                                this.manageRequestsLoaded()
                            console.log("Energy -", err);
                        });
                        }).catch((err) => {
                            console.log("Energy -", err);
                        });                            
                    }).catch((err) => {
                        console.log("Energy -", err);                            
                    })*/
                }).catch((err) => {
                    this.manageRequestsLoaded()
                    console.log("Energy -", err);
                });
            }).catch((err) => {
                this.manageRequestsLoaded()
                console.log("MB_peer/server Connected-", err);
            });           
        }).catch((err) => {
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            console.log("MB_peer/server -", err);
        });

        // rebuf_peer, rebuf_server
        this.loadRebuf().then(() => {
            this.manageRequestsLoaded()
        }).catch((err) => {
            this.manageRequestsLoaded()
            console.log("Rebufs -", err);
        });

        //client_uuid
        this.loadClientUuid().then(() => {
            this.manageRequestsLoaded()
        }).catch((err) => {
            this.manageRequestsLoaded()
            console.log("Client_uuid -", err);
        });

        //new_client_uuid
        this.loadNewClientUuid().then(() => {
            this.manageRequestsLoaded()
        }).catch((err) => {
            this.manageRequestsLoaded()
            console.log("New_Client_uuid -", err);
        });

        //represented_clients
        this.loadRepresentedClients().then(() => {
            this.manageRequestsLoaded()
            this.loadClientsConnected().then(()=>{
            this.manageRequestsLoaded();
            }).catch(err=>{
                this.manageRequestsLoaded();
                console.log("Not_connected_client - ", err)
            })
        }).catch((err) => {
            this.manageRequestsLoaded()
            this.manageRequestsLoaded()
            console.log("Represented_clients -", err);
        });

        //qualities
        this.loadQualities().then(() => {
            this.manageRequestsLoaded()
        }).catch((err) => {
            this.manageRequestsLoaded()
            console.log("Qualities -", err);
        });
        this.timeRangeType = false;
        
    },
    load_geodata() {
        return new Promise((done, reject) => {
            analyticsService.getAnalyticsFromCDN([{from: this.range.start, to:this.range.end}],this.key, this.$auth.token())
            .then(geoData => {
                this.geoCDN = geoData;
                this.geoCDN.forEach(geo => {
                    let sumData = geo.SumData;
                    let outputSumData = '';
                    let value = sumData;
                    let unit = 'B';
                    if (value > 1000000000000) {
                        unit = 'TB';
                        value = Math.round(value / 1000000000000 * 10) / 10
                    } else if (value > 1000000000) {
                        unit = 'GB';
                        value = Math.round(value / 1000000000 * 10) / 10
                    } else if (value > 1000000) {
                        unit = 'MB';
                        value = Math.round(value / 1000000 * 10) / 10
                    } else if (value > 1000) {
                        unit = 'kB';
                        value = Math.round(value / 1000 * 10) / 10
                    }
                    outputSumData += value + ' ' + unit;
                    geo._sumData = outputSumData
                })
                done(geoData);
            }).catch(err => {
                reject(err)
            })
        })
    },
    load_geodata_plugin(){
        let self = this;        
        return new Promise((done, reject) => {
        let query = {
                        "query" : {
                            "bool": {
                                "filter": {
                                    "range": {
                                        "timestamp": {
                                            "from":self.range.start,
                                            "to": self.range.end
                                        }
                                    }
                                }
                            }
                        },
                        "size": 0,
                            "aggs" : {
                            "countryCode" : 
                            {
                                "terms" : {"field":"countryCode.keyword"},
                                "aggs" : {
                                    "MB_server":{"sum":{"field" : "MB_server"}},
                                    "MB_peer":{"sum":{"field" : "MB_peer"}}
                                }
                            }
                        }
                    }
            analyticsService.getAnalyticsFromServer(self.key, query,self.$auth.token())
            .then(response=>{
                this.geoPlugin = response.aggregations.countryCode.buckets;
                done();
            }).catch(err=>{
                console.log(err)
                reject(err)
            })
        })

    },
    fillRebufChart() {
        let self= this;
        if (this.sec_rebuf.length > 0 && this.sec_peer.length > 0 && this.sec_server.length > 0 && (this.sec_rebuf[0].x.getTime() === this.sec_server[0].x.getTime()) && (this.sec_rebuf[this.sec_rebuf.length - 1].x.getTime() === this.sec_server[this.sec_server.length - 1].x.getTime()) && (this.sec_rebuf.length === this.sec_server.length)) {
            self.chartRebufdata.datasets[0].data = [];
            
            self.chartRebufdata.datasets[1].data = [];
            self.chartRebufdata.datasets[2].data = [];
            for (let i = 0; i < this.sec_rebuf.length; i++) {
                
                self.chartRebufdata.datasets[1].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: this.sec_peer[i].y + this.sec_server[i].y
                });
                self.chartRebufdata.datasets[2].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(this.sec_rebuf[i].y / (this.sec_peer[i].y + this.sec_server[i].y) * 100 * 100) / 100
                });
                if (this.sec_rebuf[i].y < 0) {
                    this.sec_rebuf[i].y = 0;
                }
                self.chartRebufdata.datasets[0].data.push({
                    x: new Date(this.sec_rebuf[i].x.getTime()), 
                    y: this.sec_rebuf[i].y
                });
            }
            self.chartRebufdata.datasets[0].data.push(...self.sec_rebuf);
            self.chartRebufLoaded = true;
        }
    },
    fillMeanViewingTime() {
        let self = this;
        if (this.client_uuid.length > 0 && this.sec_peer.length > 0 && this.sec_server.length > 0 && (this.client_uuid[0].x.getTime() === this.sec_server[0].x.getTime()) && (this.client_uuid.length === this.sec_server.length) && (this.client_uuid[this.client_uuid.length -1].x.getTime() === this.sec_server[this.sec_server.length - 1].x.getTime())) {
            self.chartMeanViewingTimedata.datasets[0].data = [];
            for (let i = 0; i < this.sec_server.length; i++) {
                self.chartMeanViewingTimedata.datasets[0].data.push({
                    x: new Date(this.sec_server[i].x.getTime()), 
                    y: (this.client_uuid[i].y === 0) ? 0 : Math.round((this.sec_peer[i].y + this.sec_server[i].y) / this.client_uuid[i].y)
                });                
            }
            self.chartMeanViewingTimeLoaded = true;
        }
    },
    fillEnergy() {
        let self = this;
        if (this.networkWifi.length > 0 && this.sec_peer.length > 0 && this.sec_server.length > 0 && (this.networkWifi[0].x.getTime() === this.sec_server[0].x.getTime()) && (this.networkWifi.length === this.sec_server.length) && (this.networkWifi[this.networkWifi.length - 1].x.getTime() === this.networkWifi[this.networkWifi.length -1].x.getTime())) {
            this.energyNormal = [];
            this.energyQuanteec = [];
            this.co2Normal = [];
            this.co2Quanteec = [];
            this.energySavingQuanteec = [];
            this.waterConsumed = [];
            this.energyNumberLength = 0;
            

            this.energyNormalIEA = [];
            this.energyQuanteecIEA = [];
            this.co2NormalIEA = [];
            this.co2QuanteecIEA = [];
            this.waterConsumedIEA = [];
            this.energySavingQuanteecIEA = [];

            this.energyNormalSHIFT = [];
            this.energyQuanteecSHIFT = [];
            this.co2NormalSHIFT = [];
            this.co2QuanteecSHIFT = [];
            this.waterConsumedSHIFT = [];
            this.energySavingQuanteecSHIFT = [];


            for (let i = 0; i < this.sec_peer.length; i++) {
                let Cdevice = 0.0020 * (this.devicePhone[i].y/3600) + 0.0050 * (this.deviceTablet[i].y/3600) + 0.0120 * (this.deviceComputer[i].y/3600);
                let Cnetwork = 0.0190 * (this.networkCellular[i].y/3600) + 0.0302 * (this.networkWifi[i].y/3600);
                let Cserver = 0.0097 * (this.timeLQ[i].y/3600) + 0.0227 * (this.timeHQ[i].y/3600);

                let offloadServer = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let offloadNetwork = 0.5 * offloadServer;

                let energyNormal = Cdevice + Cnetwork + Cserver;
                let energyQuanteec = Cdevice + (1 - offloadNetwork) * Cnetwork + (1 - offloadServer) * Cserver;

                let energySaving = (energyNormal === 0) ? 0 : (energyNormal - energyQuanteec) / energyNormal;

                energyNormal = energyNormal * Math.pow(10, 6);
                energyQuanteec = energyQuanteec * Math.pow(10, 6);

                if (energyNormal > 0) {
                    this.energyNumberLength++;
                }

                let tickDate = new Date(this.sec_server[i].x.getTime())

                this.energyNormal.push({
                    x: tickDate,
                    y: Math.round(energyNormal)
                })
                this.energyQuanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec)
                })
                this.co2Normal.push({
                    x: tickDate,
                    y: Math.round(energyNormal * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2Quanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteec.push({
                    x: tickDate,
                    y: Math.round(energySaving * 10000) / 100
                })
            }

            // Compute totals
            let totalEnergyNormal = Math.round(this.energyNormal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteec = Math.round(this.energyQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiff = Math.round((totalEnergyNormal - totalEnergyQuanteec));
            let totalCo2Normal = Math.round(this.co2Normal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Quanteec = Math.round(this.co2Quanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Diff = Math.round((totalCo2Normal - totalCo2Quanteec) * 100) / 100;
            let totalSavings = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormal - totalEnergyQuanteec) / totalEnergyNormal * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;

            this.totalEnergy = totalEnergyQuanteec;
            this.totalEnergySaved = totalEnergyDiff;
            this.totalCo2 = totalCo2Quanteec;
            this.totalCo2Saved = totalCo2Diff;
            this.totalEnergySaving = Math.round(totalSavings) + '%';
            if (this.energyNumberLength  === 0) {
                this.totalEnergySaving = 'No Data';
            }

            // Graphs
            this.chartEnergydata.datasets[0].data = this.energyNormal;
            this.chartEnergydata.datasets[1].data = this.energyQuanteec;

            this.chartCo2data.datasets[0].data = this.co2Normal;
            this.chartCo2data.datasets[1].data = this.co2Quanteec;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteec;

            this.chartEnergyLoaded = true;
            this.chartCo2Loaded = true;
            this.chartEnergySavingLoaded = true;
            this.chartEnergySavingLoadedIEA = true;
        }
    },
    fillEnergyData() {
        let self = this;
        if (this.networkWifiData.length > 0 && this.MB_peer.length > 0 && this.MB_server.length > 0 && (this.networkWifiData[0].x.getTime() === this.MB_server[0].x.getTime()) && (this.networkWifiData.length === this.MB_server.length) && (this.networkWifiData[this.networkWifiData.length - 1].x.getTime() === this.networkWifiData[this.networkWifiData.length -1].x.getTime())) {
            this.energyNormal = [];
            this.energyQuanteec = [];
            this.energySaved = [];
            this.energyDevices = [];
            this.co2Normal = [];
            this.co2Quanteec = [];
            this.energySavingQuanteec = [];
            this.energyNumberLength = 0;
            this.waterConsumedQuanteec = [];
            this.waterConsumed = [];

            this.energyNormalConnected = [];
            this.energyQuanteecConnected = [];
            this.co2NormalConnected = [];
            this.co2QuanteecConnected = [];
            this.energySavingQuanteecConnected = [];
            this.energyNumberLengthConnected = 0;

            this.energyNormalIEA = [];
            this.energyQuanteecIEA = [];
            this.energySavedIEA = [];
            this.energyDevicesIEA = [];
            this.co2NormalIEA = [];
            this.co2QuanteecIEA = [];
            this.energySavingQuanteecIEA = [];
            this.energySavingQuanteecIEAConnected = [];
            this.waterConsumedQuanteecIEA = [];
            this.waterConsumedIEA = [];


            this.energyNormalSHIFT = [];
            this.energyQuanteecSHIFT = [];
            this.energySavedSHIFT = [];
            this.energyDevicesSHIFT = [];
            this.co2NormalSHIFT = [];
            this.co2QuanteecSHIFT = [];
            this.energySavingQuanteecSHIFT = [];
            this.energySavingQuanteecSHIFTConnected = [];
            this.waterConsumedQuanteecSHIFT = [];
            this.waterConsumedSHIFT = [];

            this.energyNormalDimpact = [];
            this.energyQuanteecDimpact = [];
            this.energySavedDimpact = [];
            this.energyDevicesDimpact = [];
            this.co2NormalDimpact = [];
            this.co2QuanteecDimpact = [];
            this.energySavingQuanteecDimpact = [];
            this.energySavingQuanteecDimpactConnected = [];
            this.waterConsumedQuanteecDimpact = [];
            this.waterConsumedDimpact = [];


            for (let i = 0; i < this.MB_peer.length; i++) {
                let partGeolocCountry = 0;
                let partGeolocCountryConnected = 0;
                let partGeolocCity = 0;
                let partGeolocCityConnected = 0;
                let partGeolocRegion = 0;
                let partGeolocRegionConnected = 0;
                let partGeolocCityRegion = 0;
                let partGeolocCityRegionConnected = 0;
                let partGeolocIP = 0;
                let partGeolocIPConnected = 0;

                if(this.MB_peer[i].y != 0)
                {
                    partGeolocCountry = (this.MB_peer_country[i].y / this.MB_peer[i].y);
                    partGeolocCountryConnected = (this.MB_peer_countryConnected[i].y / this.MB_peer_connected[i].y);

                    partGeolocCity = (this.MB_peer_city[i].y / this.MB_peer[i].y);
                    partGeolocCityConnected = (this.MB_peer_cityConnected[i].y / this.MB_peer_connected[i].y);
                    
                    partGeolocRegion = (this.MB_peer_region[i].y / this.MB_peer[i].y);
                    partGeolocRegionConnected = (this.MB_peer_regionConnected[i].y / this.MB_peer_connected[i].y);

                    partGeolocCityRegion = (this.MB_peer_city[i].y / this.MB_peer[i].y) +  (this.MB_peer_region[i].y / this.MB_peer[i].y);
                    partGeolocCityRegionConnected = (this.MB_peer_cityConnected[i].y / this.MB_peer_connected[i].y) +  (this.MB_peer_regionConnected[i].y / this.MB_peer_connected[i].y);

                    partGeolocIP = (this.MB_peer_ip[i].y / this.MB_peer[i].y);
                    partGeolocIPConnected = (this.MB_peer_ipConnected[i].y / this.MB_peer_connected[i].y);
                }


                /*****IEA (time based)*/
                //Valeur en kWh 
                let CdeviceTotalIEA = 0.0020 * (this.devicePhone[i].y/3600) + 0.0050 * (this.deviceTablet[i].y/3600) + 0.0360 * (this.deviceComputer[i].y/3600);
                let CnetworkTotalIEA = 0.0190 * (this.networkCellular[i].y/3600) + 0.0302 * (this.networkWifi[i].y/3600);
                let CserverTotalIEA = 0.0023 * (this.timeLQ[i].y/3600) + 0.0097 * (this.timeHQ[i].y/3600);
                
                let offloadServerIEA = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let offloadNetworkIEA = partGeolocCityRegion * offloadServerIEA;

                let CnetworkQuanteecIEA = CnetworkTotalIEA * ((1-offloadServerIEA)  + offloadServerIEA * partGeolocCountry + 0.45 * offloadServerIEA * partGeolocRegion + 0.08 * offloadServerIEA * partGeolocRegion)
                //(1-offloadNetworkIEA) * CnetworkTotalIEA - (partGeolocIP*offloadServerIEA*CnetworkTotalIEA);
                let CserverQuanteecIEA = (1-offloadServerIEA) * CserverTotalIEA

                let energyNormalIEA = CnetworkTotalIEA + CserverTotalIEA;
                let energyQuanteecIEA = CnetworkQuanteecIEA + CserverQuanteecIEA
                let energyDevicesIEA = CdeviceTotalIEA;
                //console.log(`IEA : device ${CdeviceTotalIEA} network ${CnetworkTotalIEA} server ${CserverTotalIEA} offload: ${offloadServerIEA}`);


                let energySavingIEA = (energyNormalIEA === 0) ? 0 : (energyNormalIEA - energyQuanteecIEA) / energyNormalIEA;

                energyNormalIEA = energyNormalIEA * Math.pow(10, 6);
                energyQuanteecIEA = energyQuanteecIEA * Math.pow(10, 6);
                energyDevicesIEA = CdeviceTotalIEA * Math.pow(10, 6);
                let energySavedIEA = energyNormalIEA - energyQuanteecIEA;


                let tickDate = new Date(this.MB_server[i].x.getTime())

                this.energyNormalIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEA)
                })

                this.energyQuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEA)
                })

                this.energySavedIEA.push({
                    x: tickDate,
                    y: Math.round(energySavedIEA)
                })

                this.energyDevicesIEA.push({
                    x: tickDate,
                    y: Math.round(energyDevicesIEA)
                })


                this.waterConsumedIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEA*0.00219)
                })

                this.waterConsumedQuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEA*0.00219)
                })

                this.co2NormalIEA.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEA * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEA * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecIEA.push({
                    x: tickDate,
                    y: Math.round(energySavingIEA * 10000) / 100
                })

                /*****IEA Connected (time based)*/

                /**TODO Calculer les valeurs pour les peers connectés entre eux */
                let CdeviceTotalIEAConnected = 0.0020 * (this.devicePhoneConnected[i].y/3600) + 0.0050 * (this.deviceTabletConnected[i].y/3600) + 0.0360 * (this.deviceComputerConnected[i].y/3600);
                let CnetworkTotalIEAConnected = 0.0190 * (this.networkCellularConnected[i].y/3600) + 0.0302 * (this.networkWifiConnected[i].y/3600);
                let CserverTotalIEAConnected = 0.0023 * (this.timeLQConnected[i].y/3600) + 0.0097 * (this.timeHQConnected[i].y/3600);

                let offloadServerIEAConnected = (this.sec_server_connected[i].y + this.sec_peer_connected[i].y === 0 )? 0 : this.sec_peer_connected[i].y / (this.sec_server_connected[i].y + this.sec_peer_connected[i].y);
                let offloadNetworkIEAConnected = partGeolocCityRegionConnected * offloadServerIEAConnected;

                let CnetworkQuanteecIEAConnected = CnetworkTotalIEAConnected * ((1-offloadServerIEAConnected)  + offloadServerIEAConnected * partGeolocCountry + 0.45 * offloadServerIEAConnected * partGeolocRegion + 0.08 * offloadServerIEAConnected * partGeolocRegion)
                //(1-offloadNetworkIEAConnected) * CnetworkTotalIEAConnected - (partGeolocIPConnected * offloadServerIEAConnected * CnetworkTotalIEAConnected)
                let CserverQuanteecIEAConnected = (1-offloadServerIEAConnected) * CserverTotalIEAConnected

                let energyNormalIEAConnected = CnetworkTotalIEAConnected + CserverTotalIEAConnected;
                let energyQuanteecIEAConnected = CnetworkQuanteecIEAConnected + CserverQuanteecIEAConnected
                let energyDevicesIEAConnected = CdeviceTotalIEAConnected;

                //console.log(`IEACo : device ${CdeviceTotalIEAConnected} network ${CnetworkTotalIEAConnected} server ${CserverTotalIEAConnected} offload: ${offloadServerIEAConnected}`);


                let energySavingIEAConnected = (energyNormalIEAConnected === 0) ? 0 : (energyNormalIEAConnected - energyQuanteecIEAConnected) / energyNormalIEAConnected;

                energyNormalIEAConnected = energyNormalIEAConnected * Math.pow(10, 6);
                energyQuanteecIEAConnected = energyQuanteecIEAConnected * Math.pow(10, 6);
                energyDevicesIEAConnected = energyDevicesIEAConnected * Math.pow(10, 6);


                this.energyNormalIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEAConnected)
                })
                this.energyQuanteecIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEAConnected)
                })
                this.energyDevicesIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyDevicesIEAConnected)
                })
                this.co2NormalIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalIEAConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecIEAConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecIEAConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingIEAConnected * 10000) / 100
                })


                /*****SHIFT*/

                //SHIFT ==> Valeur en kwh/kB
                let CserverTotalSHIFT = 0.000000072 * this.MB_server[i].y + 0.000000072 * this.MB_peer[i].y
                let CserverQuanteecSHIFT = 0.000000072 * this.MB_server[i].y

                let offloadShift = (this.MB_peer[i].y + this.MB_server[i].y !== 0) ? this.MB_peer[i].y / (this.MB_peer[i].y + this.MB_server[i].y) : 0
                let CnetworkTotalSHIFT = 0.000000152 * (this.networkWifiData[i].y) + 0.000000884 * (this.networkCellularData[i].y)
                let CnetworkQuanteecSHIFT = CnetworkTotalSHIFT * ((1-offloadShift)  + offloadShift * partGeolocCountry + 0.45 * offloadShift * partGeolocRegion + 0.08 * offloadShift * partGeolocRegion)
                
                let CdeviceTotalSHIFT = 0.00011 * (this.devicePhone[i].y/60) + 0.00022 * (this.deviceTablet[i].y/60) + 0.00032 * (this.deviceComputer[i].y/60);
                
                
                let energyNormalSHIFT = CnetworkTotalSHIFT + CserverTotalSHIFT;
                let energyQuanteecSHIFT = CnetworkQuanteecSHIFT + CserverQuanteecSHIFT
                let energyDevicesSHIFT = CdeviceTotalSHIFT

                let energySavingSHIFT = (energyNormalSHIFT === 0) ? 0 : (energyNormalSHIFT - energyQuanteecSHIFT) / energyNormalSHIFT;

                energyNormalSHIFT = energyNormalSHIFT * Math.pow(10, 6);
                energyQuanteecSHIFT = energyQuanteecSHIFT * Math.pow(10, 6);
                energyDevicesSHIFT = energyDevicesSHIFT * Math.pow(10, 6);
                let energySavedSHIFT = energyNormalSHIFT - energyQuanteecSHIFT;

                //console.log(`SHIFT : device ${CdeviceTotalSHIFT} network ${CnetworkTotalSHIFT} server ${CserverTotalSHIFT} ${CserverQuanteecSHIFT}`);
                //console.log(`SHIFT Co : ${energyNormalSHIFT} ${energyQuanteecSHIFT} ${energySavingSHIFT}`);



                this.energyNormalSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFT)
                })
                this.energyQuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFT)
                })

                this.energySavedSHIFT.push({
                    x: tickDate,
                    y: Math.round(energySavedSHIFT)
                })
                this.energyDevicesSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyDevicesSHIFT)
                })
                


                this.waterConsumedSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFT*0.00219)
                })

                this.waterConsumedQuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFT*0.00219)
                })


                this.co2NormalSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFT * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFT * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecSHIFT.push({
                    x: tickDate,
                    y: Math.round(energySavingSHIFT * 10000) / 100
                })

                /*****SHIFT CONNECTED*/

                //SHIFT ==> Valeur en kwh/kB
                let CserverTotalSHIFTConnected = 0.000000072 * this.MB_server_connected[i].y + 0.000000072 * this.MB_peer_connected[i].y
                let CserverQuanteecSHIFTConnected = 0.000000072 * this.MB_server_connected[i].y

                let offloadShiftConnected = (this.MB_peer_connected[i].y + this.MB_server_connected[i].y !== 0) ? this.MB_peer_connected[i].y / (this.MB_peer_connected[i].y + this.MB_server_connected[i].y) : 0
                let CnetworkTotalSHIFTConnected = 0.000000152 * (this.networkWifiDataConnected[i].y) + 0.000000884 * (this.networkCellularDataConnected[i].y)
                let CnetworkQuanteecSHIFTConnected = CnetworkTotalSHIFTConnected * ((1-offloadShiftConnected)  + offloadShiftConnected * partGeolocCountry + 0.45 * offloadShiftConnected * partGeolocRegion + 0.08 * offloadShiftConnected * partGeolocRegion)
                //(1 - (partGeolocCityRegionConnected * offloadShiftConnected)) * CnetworkTotalSHIFTConnected - (partGeolocIPConnected*offloadShiftConnected*CnetworkTotalSHIFTConnected)
                                
                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalSHIFTConnected = 0.00011 * (this.devicePhoneDataConnected[i].y/60) + 0.00022 * (this.deviceTabletDataConnected[i].y/60) + 0.00032 * (this.deviceComputerDataConnected[i].y/60);

                let energyNormalSHIFTConnected = CnetworkTotalSHIFTConnected + CserverTotalSHIFTConnected;
                let energyQuanteecSHIFTConnected = CnetworkQuanteecSHIFTConnected + CserverQuanteecSHIFTConnected;
                let energyDevicesSHIFTConnected = CdeviceTotalSHIFTConnected;

                let energySavingSHIFTConnected = (energyNormalSHIFTConnected === 0) ? 0 : (energyNormalSHIFTConnected - energyQuanteecSHIFTConnected) / energyNormalSHIFTConnected;

                energyNormalSHIFTConnected = energyNormalSHIFTConnected * Math.pow(10, 6);
                energyQuanteecSHIFTConnected = energyQuanteecSHIFTConnected * Math.pow(10, 6);
                energyDevicesSHIFTConnected = energyDevicesSHIFTConnected * Math.pow(10, 6);

                //console.log(`SHIFT Co : device ${CdeviceTotalSHIFTConnected} network ${CnetworkTotalSHIFTConnected} server ${CserverTotalSHIFTConnected} ${CserverQuanteecSHIFTConnected}`);
                //console.log(`SHIFT Co : ${energyNormalSHIFTConnected} ${energyQuanteecSHIFTConnected} ${energySavingSHIFTConnected}`);

                this.energyNormalSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFTConnected)
                })
                this.energyQuanteecSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFTConnected)
                })
                this.energyDevicesSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyDevicesSHIFTConnected)
                })
                this.co2NormalSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalSHIFTConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecSHIFTConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecSHIFTConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingSHIFTConnected * 10000) / 100
                })                

                /*****QUANTEEC*/

                //SHIFT ==> Valeur en kwh/kB
                //let CserverTotal = 0.000000072 * this.MB_server[i].y + 0.000000072 * this.MB_peer[i].y
                //let CserverQuanteec = 0.000000072 * this.MB_server[i].y
                let CserverTotal = 0.0023 * (this.timeLQ[i].y/3600) + 0.0097 * (this.timeHQ[i].y/3600);
                
                let offloadServerQuanteec = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let CserverQuanteec = (1-offloadServerQuanteec) * CserverTotal


                let CnetworkTotal = 0.0000000535 * (this.MB_peer[i].y + this.MB_server[i].y) //(0.000152 * this.networkWifiData[i].y + 0.000884 * this.networkCellularData[i].y            
                let CnetworkQuanteec = 0.0000000535 * this.MB_server[i].y + 0.0000000535 * this.MB_peer_country[i].y + 0.0000000243 * this.MB_peer_region[i].y + 0.0000000043 *  this.MB_peer_city[i].y 
                
                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotal = 0.0020 * (this.devicePhone[i].y/3600) + 0.0050 * (this.deviceTablet[i].y/3600) + 0.0360 * (this.deviceComputer[i].y/3600);
                //console.log(`Quanteec : device ${CdeviceTotal} network ${CnetworkTotal} server ${CserverTotal}`);
                let energyNormal = CnetworkTotal + CserverTotal;
                let energyQuanteec = CnetworkQuanteec + CserverQuanteec;
                let energyDevices = CdeviceTotal;

                let energySaving = (energyNormal === 0) ? 0 : (energyNormal - energyQuanteec) / energyNormal;

                energyNormal = energyNormal * Math.pow(10, 6);
                energyQuanteec = energyQuanteec * Math.pow(10, 6);
                energyDevices = energyDevices * Math.pow(10, 6);
                let energySaved = energyNormal - energyQuanteec;

                if (energyNormal > 0) {
                    this.energyNumberLength++;
                }

                this.energyNormal.push({
                    x: tickDate,
                    y: Math.round(energyNormal)
                })

                this.energySaved.push({
                    x: tickDate,
                    y: Math.round(energySaved)
                })

                this.energyQuanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec)
                })

                this.energyDevices.push({
                    x: tickDate,
                    y: Math.round(energyDevices)
                })

                this.waterConsumed.push({
                    x: tickDate,
                    y: Math.round(energyNormal*0.00219)
                })

                this.waterConsumedQuanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec*0.00219)
                })

                this.co2Normal.push({
                    x: tickDate,
                    y: Math.round(energyNormal * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2Quanteec.push({
                    x: tickDate,
                    y: Math.round(energyQuanteec * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteec.push({
                    x: tickDate,
                    y: Math.round(energySaving * 10000) / 100
                })




                //SHIFT ==> Valeur en kwh/kB
                //let CserverTotalConnected = 0.000000072 * this.MB_server_connected[i].y + 0.000000072 * this.MB_peer_connected[i].y
                //let CserverQuanteecConnected = 0.000000072 * this.MB_server_connected[i].y
                let CserverTotalConnected = 0.0023 * (this.timeLQConnected[i].y/3600) + 0.0097 * (this.timeHQConnected[i].y/3600);
                
                let offloadServerQuanteecConnected = (this.sec_server_connected[i].y + this.sec_peer_connected[i].y === 0 )? 0 : this.sec_peer_connected[i].y / (this.sec_server_connected[i].y + this.sec_peer_connected[i].y);
                let CserverQuanteecConnected = (1-offloadServerQuanteecConnected) * CserverTotalConnected
                /**
                 * TO-DO à modifier pour le network : 
                 * Enregistrer d'ou viennent les data (pays, régions, ville)
                 * Formule 
                 *  let CnetworkQuanteec = 0.0000000535 * this.MB_server[i].y + 0.0000000535 * this.MB_peerCountry[i].y + 0.0000000243 * this.MB_peerRegion[i].y + 0.0000000043 *  this.MB_peerCity[i].y 
                 */
                let CnetworkTotalConnected = 0.0000000535 * (this.MB_peer_connected[i].y + this.MB_server_connected[i].y) //(0.000152 * this.networkWifiData[i].y + 0.000884 * this.networkCellularData[i].y            
                let CnetworkQuanteecConnected = 0.0000000535 * this.MB_server_connected[i].y + 0.0000000535 * this.MB_peer_countryConnected[i].y + 0.0000000243 * this.MB_peer_regionConnected[i].y + 0.0000000043 *  this.MB_peer_cityConnected[i].y 
                
                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalConnected = 0.0020 * (this.devicePhoneConnected[i].y/3600) + 0.0050 * (this.deviceTabletConnected[i].y/3600) + 0.0360 * (this.deviceComputerConnected[i].y/3600);


                let energyNormalConnected = CnetworkTotalConnected + CserverTotalConnected;
                let energyQuanteecConnected = CnetworkQuanteecConnected + CserverQuanteecConnected
                let energyDevicesConnected = CdeviceTotalConnected;

                let energySavingConnected = (energyNormalConnected === 0) ? 0 : (energyNormalConnected - energyQuanteecConnected) / energyNormalConnected;

                energyNormalConnected = energyNormalConnected * Math.pow(10, 6);
                energyQuanteecConnected = energyQuanteecConnected * Math.pow(10, 6);
                energyDevicesConnected = energyDevicesConnected * Math.pow(10, 6);

                if (energyNormalConnected > 0) {
                    this.energyNumberLengthConnected++;
                }

                this.energyNormalConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalConnected)
                })
                this.energyQuanteecConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecConnected)
                })
                this.energyDevicesConnected.push({
                    x: tickDate,
                    y: Math.round(energyDevicesConnected)
                })
                this.co2NormalConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingConnected * 10000) / 100
                })



                /*****DIMPACT*/

                //Dimpact Carbon Trust value ==>
                let CserverTotalDimpact = 0.0013 * (this.timeLQ[i].y/3600) + 0.0013 * (this.timeHQ[i].y/3600);
                let offloadServerDimpact = (this.sec_server[i].y + this.sec_peer[i].y === 0 )? 0 : this.sec_peer[i].y / (this.sec_server[i].y + this.sec_peer[i].y);
                let CserverQuanteecDimpact = CserverTotalDimpact * (1-offloadServerDimpact)


                let CnetworkTotalDimpact = 0.000000006*(this.networkWifiData[i].y) + 0.0000001*(this.networkCellularData[i].y);      
                let CnetworkTotalDimpactWithoutCPE = 0.000000006*(this.networkWifiData[i].y) + 0.0000001*(this.networkCellularData[i].y);
                let offloadNetworkDimpact = partGeolocCityRegion * offloadServerDimpact;
                let CnetworkQuanteecDimpact = CnetworkTotalDimpactWithoutCPE * ((1-offloadServerDimpact)  + offloadServerDimpact * partGeolocCountry + 0.45 * offloadServerDimpact * partGeolocRegion + 0.08 * offloadServerDimpact * partGeolocRegion) + 0.000000011 * (this.networkWifi[i].y/3600);  
                
                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalDimpact = 0.0020 * (this.devicePhone[i].y/3600) + 0.0055 * (this.deviceTablet[i].y/3600) + 0.03 * (this.deviceComputer[i].y/3600) + 0.000000011 * (this.networkWifi[i].y/3600);

                let energyNormalDimpact = CnetworkTotalDimpact + CserverTotalDimpact;
                let energyQuanteecDimpact = CnetworkQuanteecDimpact + CserverQuanteecDimpact
                let energyDevicesDimpact = CdeviceTotalDimpact;

                let energySavingDimpact = (energyNormal === 0) ? 0 : (energyNormalDimpact - energyQuanteecDimpact) / energyNormalDimpact;

                energyNormalDimpact = energyNormalDimpact * Math.pow(10, 6);
                energyQuanteecDimpact = energyQuanteecDimpact * Math.pow(10, 6);
                energyDevicesDimpact = energyDevicesDimpact * Math.pow(10, 6);
                let energySavedDimpact = energyNormalDimpact - energyQuanteecDimpact;


                this.energyNormalDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpact)
                })
                this.energyQuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpact)
                })
                this.energySavedDimpact.push({
                    x: tickDate,
                    y: Math.round(energySavedDimpact)
                })
                this.energyDevicesDimpact.push({
                    x: tickDate,
                    y: Math.round(energyDevicesDimpact)
                })

                this.waterConsumedDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpact*0.00219)
                })

                this.waterConsumedQuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpact*0.00219)
                })

                this.co2NormalDimpact.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpact * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpact * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecDimpact.push({
                    x: tickDate,
                    y: Math.round(energySavingDimpact * 10000) / 100
                })


                //Dimpact Connected
                //SHIFT ==> Valeur en kwh/kB
                let CserverTotalDimpactConnected = 0.0013 * (this.timeLQConnected[i].y/3600) + 0.0013 * (this.timeHQConnected[i].y/3600);
                let offloadServerDimpactConnected = (this.sec_server_connected[i].y + this.sec_peer_connected[i].y === 0 )? 0 : this.sec_peer_connected[i].y / (this.sec_server_connected[i].y + this.sec_peer_connected[i].y);
                let CserverQuanteecDimpactConnected = CserverTotalDimpactConnected * (1-offloadServerDimpactConnected)

                let CnetworkTotalDimpactConnected = 0.000000006*(this.networkWifiDataConnected[i].y) + 0.0000001*(this.networkCellularDataConnected[i].y);    
                let CnetworkTotalDimpactWithoutCPEConnected = 0.000000006*(this.networkWifiDataConnected[i].y) + 0.0000001*(this.networkCellularDataConnected[i].y);
                let offloadNetworkDimpactConnected = partGeolocCityRegionConnected * offloadServerDimpactConnected;
                let CnetworkQuanteecDimpactConnected = CnetworkTotalDimpactWithoutCPEConnected * ((1-offloadServerDimpactConnected)  + offloadServerDimpactConnected * partGeolocCountry + 0.45 * offloadServerDimpactConnected * partGeolocRegion + 0.08 * offloadServerDimpactConnected * partGeolocRegion) + 0.000000011 * (this.networkWifi[i].y/3600)+ 0.000000011 * (this.networkWifiConnected[i].y/3600);    
                //((1-offloadNetworkDimpactConnected) * CnetworkTotalDimpactWithoutCPEConnected) + 0.000000011 * (this.networkWifiConnected[i].y/3600) - (partGeolocIPConnected*offloadServerDimpactConnected*CnetworkTotalDimpactWithoutCPEConnected);

                //Ancien mais avec le nombre de viewer par minutes et par device En kWh
                let CdeviceTotalDimpactConnected = 0.0020 * (this.devicePhoneConnected[i].y/3600) + 0.0055 * (this.deviceTabletConnected[i].y/3600) + 0.03 * (this.deviceComputerConnected[i].y/3600);


                let energyNormalDimpactConnected = CnetworkTotalDimpactConnected + CserverTotalDimpactConnected;
                let energyQuanteecDimpactConnected = CnetworkQuanteecDimpactConnected + CserverQuanteecDimpactConnected
                let energyDevicesDimpactConnected = CdeviceTotalDimpactConnected;

                let energySavingDimpactConnected = (energyNormalDimpactConnected === 0) ? 0 : (energyNormalDimpactConnected - energyQuanteecDimpactConnected) / energyNormalDimpactConnected;

                energyNormalDimpactConnected = energyNormalDimpactConnected * Math.pow(10, 6);
                energyQuanteecDimpactConnected = energyQuanteecDimpactConnected * Math.pow(10, 6);
                energyDevicesDimpactConnected = energyDevicesDimpactConnected * Math.pow(10, 6);

                this.energyNormalDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpactConnected)
                })
                this.energyQuanteecDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpactConnected)
                })
                this.energyDevicesDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpactConnected)
                })
                this.co2NormalDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyNormalDimpactConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.co2QuanteecDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energyQuanteecDimpactConnected * this.indiceCo2 * Math.pow(10, -3))
                })
                this.energySavingQuanteecDimpactConnected.push({
                    x: tickDate,
                    y: Math.round(energySavingDimpactConnected * 10000) / 100
                })
            }

            // Compute totals
            /**QUANTEEC */
            let totalEnergyNormal = Math.round(this.energyNormal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteec = Math.round(this.energyQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevices = Math.round(this.energyDevices.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalConnected = Math.round(this.energyNormalConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecConnected = Math.round(this.energyQuanteecConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesConnected = Math.round(this.energyDevicesConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiff = Math.round((totalEnergyNormal - totalEnergyQuanteec));
            let totalCo2Normal = Math.round(this.co2Normal.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Quanteec = Math.round(this.co2Quanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2Diff = Math.round((totalCo2Normal - totalCo2Quanteec) * 100) / 100;
            let totalSavings = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormal - totalEnergyQuanteec) / totalEnergyNormal * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalConnected - totalEnergyQuanteecConnected) / totalEnergyNormalConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWater = totalEnergyQuanteec*0.00219;
            let totalWaterSaved = totalEnergyDiff*0.00219;

            this.totalEnergy = totalEnergyQuanteec;
            this.totalEnergyDevices = totalEnergyDevices;
            this.totalEnergySaved = totalEnergyDiff;
            this.totalLightsSaved = Math.round(totalEnergyDiff / 1000 / 30 * 10) / 10;
            this.totalHouseSaved = Math.round(totalEnergyDiff / 1000 / 13000 * 10) / 10;
            //this.totalLightsSaved = this.totalLightsSaved.toExponential(2);
            this.totalCo2 = totalCo2Quanteec;
            this.totalCo2Saved = totalCo2Diff;
            this.totalKmSaved = Math.round(totalCo2Diff /1000 / 653);
            this.totalEnergySaving = Math.round(totalSavings) + '%';
            this.totalEnergySavingConnected = Math.round(totalSavingsConnected) + '%';
            if (this.energyNumberLength  === 0) {
                this.totalEnergySaving = 'No Data';
                this.totalEnergySavingConnected = 'No Data';
            }
            this.totalWater = totalWater;
            this.totalWaterSaved = totalWaterSaved

            /****IEA */
            let totalEnergyNormalIEA = Math.round(this.energyNormalIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecIEA = Math.round(this.energyQuanteecIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesIEA = Math.round(this.energyDevicesIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalIEAConnected = Math.round(this.energyNormalIEAConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecIEAConnected = Math.round(this.energyQuanteecIEAConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiffIEA = Math.round((totalEnergyNormalIEA - totalEnergyQuanteecIEA));
            let totalCo2NormalIEA = Math.round(this.co2NormalIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2QuanteecIEA = Math.round(this.co2QuanteecIEA.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2DiffIEA = Math.round((totalCo2NormalIEA - totalCo2QuanteecIEA) * 100) / 100;
            let totalSavingsIEA = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormalIEA - totalEnergyQuanteecIEA) / totalEnergyNormalIEA * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsIEAConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalIEAConnected - totalEnergyQuanteecIEAConnected) / totalEnergyNormalIEAConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWaterIEA = totalEnergyQuanteecIEA*0.00219;
            let totalWaterSavedIEA = totalEnergyDiffIEA*0.00219;

            //if (totalSavingsIEAConnected < totalSavingsIEA) {totalSavingsIEAConnected = totalSavingsIEA}


            this.totalEnergyIEA = totalEnergyQuanteecIEA;
            this.totalEnergyDevicesIEA = totalEnergyDevicesIEA;
            //console.log(this.totalEnergyIEA)
            //console.log(this.energyQuanteecIEA)
            this.totalEnergySavedIEA = totalEnergyDiffIEA;
            this.totalLightsSavedIEA = Math.round(totalEnergyDiffIEA / 1000 / 30 * 10) / 10;
            this.totalHouseSavedIEA = Math.round(totalEnergyDiffIEA / 1000 / 13000 * 10) / 10;
            //this.totalLightsSavedIEA = this.totalLightsSavedIEA.toExponential(2);
            this.totalCo2IEA = totalCo2QuanteecIEA;
            this.totalCo2SavedIEA = totalCo2DiffIEA;
            this.totalKmSavedIEA = Math.round(totalCo2DiffIEA /1000 / 653);
            this.totalEnergySavingIEA = Math.round(totalSavingsIEA) + '%';
            this.totalEnergySavingConnectedIEA = Math.round(totalSavingsIEAConnected) + '%';
            if (this.energyNumberLength  === 0) {
                this.totalEnergySavingIEA = 'No Data';
                this.totalEnergySavingConnectedIEA = 'No Data';
            }
            this.totalWaterIEA = totalWaterIEA;
            this.totalWaterSavedIEA = totalWaterSavedIEA

            /****SHIFT */
            let totalEnergyNormalSHIFT = Math.round(this.energyNormalSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecSHIFT = Math.round(this.energyQuanteecSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesSHIFT = Math.round(this.energyDevicesSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalSHIFTConnected = Math.round(this.energyNormalSHIFTConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecSHIFTConnected = Math.round(this.energyQuanteecSHIFTConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiffSHIFT = Math.round((totalEnergyNormalSHIFT - totalEnergyQuanteecSHIFT));
            let totalCo2NormalSHIFT = Math.round(this.co2NormalSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2QuanteecSHIFT = Math.round(this.co2QuanteecSHIFT.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2DiffSHIFT = Math.round((totalCo2NormalSHIFT - totalCo2QuanteecSHIFT) * 100) / 100;
            let totalSavingsSHIFT = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormalSHIFT - totalEnergyQuanteecSHIFT) / totalEnergyNormalSHIFT * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsSHIFTConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalSHIFTConnected - totalEnergyQuanteecSHIFTConnected) / totalEnergyNormalSHIFTConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWaterSHIFT = totalEnergyQuanteecSHIFT*0.00219;
            let totalWaterSavedSHIFT = totalEnergyDiffSHIFT*0.00219;
            //if (totalSavingsSHIFTConnected < totalSavingsSHIFT) {totalSavingsSHIFTConnected = totalSavingsSHIFT}

            this.totalEnergySHIFT = totalEnergyQuanteecSHIFT;
            this.totalEnergyDevicesSHIFT = totalEnergyDevicesSHIFT;
            this.totalEnergySavedSHIFT = totalEnergyDiffSHIFT;
            this.totalLightsSavedSHIFT = Math.round(totalEnergyDiffSHIFT / 1000 / 30 * 10) / 10;
            this.totalHouseSavedSHIFT = Math.round(totalEnergyDiffSHIFT / 1000 / 13000 * 10) / 10;
            //this.totalLightsSavedSHIFT = this.totalLightsSavedSHIFT.toExponential(2);
            this.totalCo2SHIFT = totalCo2QuanteecSHIFT;
            //console.log(this.co2QuanteecSHIFT)
            this.totalCo2SavedSHIFT = totalCo2DiffSHIFT;
            this.totalKmSavedSHIFT = Math.round(totalCo2DiffSHIFT /1000 / 653);
            this.totalEnergySavingSHIFT = Math.round(totalSavingsSHIFT) + '%';
            this.totalEnergySavingConnectedSHIFT = Math.round(totalSavingsSHIFTConnected) + '%';
            if (this.energyNumberLength  === 0) {
                this.totalEnergySavingSHIFT = 'No Data';
                this.totalEnergySavingConnectedSHIFT = 'No Data';
            }
            this.totalWaterSHIFT = totalWaterSHIFT;
            this.totalWaterSavedSHIFT = totalWaterSavedSHIFT

            /****Dimpact */
            let totalEnergyNormalDimpact = Math.round(this.energyNormalDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecDimpact = Math.round(this.energyQuanteecDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDevicesDimpact = Math.round(this.energyDevicesDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyNormalDimpactConnected = Math.round(this.energyNormalDimpactConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyQuanteecDimpactConnected = Math.round(this.energyQuanteecDimpactConnected.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalEnergyDiffDimpact = Math.round((totalEnergyNormalDimpact - totalEnergyQuanteecDimpact));
            let totalCo2NormalDimpact = Math.round(this.co2NormalDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2QuanteecDimpact = Math.round(this.co2QuanteecDimpact.reduce((a,b)=> {return {y: a.y + b.y}}).y);
            let totalCo2DiffDimpact = Math.round((totalCo2NormalDimpact - totalCo2QuanteecDimpact) * 100) / 100;
            let totalSavingsDimpact = (this.energyNumberLength  === 0) ? 0 : Math.round((totalEnergyNormalDimpact - totalEnergyQuanteecDimpact) / totalEnergyNormalDimpact * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalSavingsDimpactConnected = (this.energyNumberLengthConnected  === 0) ? 0 : Math.round((totalEnergyNormalDimpactConnected - totalEnergyQuanteecDimpactConnected) / totalEnergyNormalDimpactConnected * 1000) / 10 //Math.round((this.energySavingQuanteec.reduce((a,b)=> {return {y: a.y + b.y}}).y) / this.energyNumberLength * 100) / 100;
            let totalWaterDimpact = totalEnergyQuanteecDimpact*0.00219;
            let totalWaterSavedDimpact = totalEnergyDiffDimpact*0.00219;
            //if (totalSavingsDimpactConnected < totalSavingsDimpact) {totalSavingsDimpactConnected = totalSavingsDimpact}

            this.totalEnergyDimpact = totalEnergyQuanteecDimpact;
            this.totalEnergyDevicesDimpact = totalEnergyDevicesDimpact;
            this.totalEnergySavedDimpact = totalEnergyDiffDimpact;
            this.totalLightsSavedDimpact = Math.round(totalEnergyDiffDimpact / 1000 / 30 * 10) / 10;
            this.totalHouseSavedDimpact = Math.round(totalEnergyDiffDimpact / 1000 / 13000 * 10) / 10;
            //this.totalLightsSavedDimpact = this.totalLightsSavedDimpact.toExponential(2);
            this.totalCo2Dimpact = totalCo2QuanteecDimpact;
            //console.log(this.co2QuanteecDimpact)
            this.totalCo2SavedDimpact = totalCo2DiffDimpact;
            this.totalKmSavedDimpact = Math.round(totalCo2DiffDimpact /1000 / 653);
            this.totalEnergySavingDimpact = Math.round(totalSavingsDimpact) + '%';
            this.totalEnergySavingConnectedDimpact = Math.round(totalSavingsDimpactConnected) + '%';
            if (this.energyNumberLength  === 0) {
                this.totalEnergySavingDimpact = 'No Data';
                this.totalEnergySavingConnectedDimpact = 'No Data';
            }
            this.totalWaterDimpact = totalWaterDimpact;
            this.totalWaterSavedDimpact = totalWaterSavedDimpact



            // Graphs ==> On laise les valeurs par défaut
            
            this.chartEnergydata.datasets[0].data = this.energyDevices;
            this.chartEnergydata.datasets[1].data = this.energyQuanteec;
            this.chartEnergydata.datasets[2].data = this.energyNormal;

            this.chartCo2data.datasets[0].data = this.co2Normal;
            this.chartCo2data.datasets[1].data = this.co2Quanteec;

            this.chartEnergydataIEA.datasets[0].data = this.energyDevicesIEA;
            this.chartEnergydataIEA.datasets[1].data = this.energyQuanteecIEA;
            this.chartEnergydataIEA.datasets[2].data = this.energyNormalIEA;


            this.chartCo2dataIEA.datasets[0].data = this.co2NormalIEA;
            this.chartCo2dataIEA.datasets[1].data = this.co2QuanteecIEA;

            this.chartEnergydataSHIFT.datasets[0].data = this.energyDevicesSHIFT;
            this.chartEnergydataSHIFT.datasets[1].data = this.energyQuanteecSHIFT;
            this.chartEnergydataSHIFT.datasets[2].data = this.energyNormalSHIFT;


            this.chartCo2dataSHIFT.datasets[0].data = this.co2NormalSHIFT;
            this.chartCo2dataSHIFT.datasets[1].data = this.co2QuanteecSHIFT;

            this.chartEnergydataDimpact.datasets[0].data = this.energyDevicesDimpact;
            this.chartEnergydataDimpact.datasets[1].data = this.energyQuanteecDimpact;
            this.chartEnergydataDimpact.datasets[2].data = this.energyNormalDimpact;


            this.chartCo2dataDimpact.datasets[0].data = this.co2NormalDimpact;
            this.chartCo2dataDimpact.datasets[1].data = this.co2QuanteecDimpact;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteec;
            this.chartEnergySavingdata.datasets[1].data = this.energySavingQuanteecConnected;

            this.chartEnergySavingdataIEA.datasets[0].data = this.energySavingQuanteecIEA;
            this.chartEnergySavingdataIEA.datasets[1].data = this.energySavingQuanteecIEAConnected;

            this.chartEnergySavingdataSHIFT.datasets[0].data = this.energySavingQuanteecSHIFT;
            this.chartEnergySavingdataSHIFT.datasets[1].data = this.energySavingQuanteecSHIFTConnected;

            this.chartEnergySavingdataDimpact.datasets[0].data = this.energySavingQuanteecDimpact;
            this.chartEnergySavingdataDimpact.datasets[1].data = this.energySavingQuanteecDimpactConnected;

            this.chartWaterdata.datasets[0].data = this.waterConsumed
            this.chartWaterdata.datasets[1].data = this.waterConsumedQuanteec
            
            this.chartWaterdataIEA.datasets[0].data = this.waterConsumedIEA
            this.chartWaterdataIEA.datasets[1].data = this.waterConsumedQuanteecIEA

            this.chartWaterdataSHIFT.datasets[0].data = this.waterConsumedSHIFT
            this.chartWaterdataSHIFT.datasets[1].data = this.waterConsumedQuanteecSHIFT

            this.chartWaterdataDimpact.datasets[0].data = this.waterConsumedDimpact
            this.chartWaterdataDimpact.datasets[1].data = this.waterConsumedQuanteecDimpact



            this.chartEnergyLoaded = true;
            this.chartCo2Loaded = true;
            this.chartEnergyLoadedIEA = true;
            this.chartCo2LoadedIEA = true;
            this.chartEnergyLoadedSHIFT = true;
            this.chartCo2LoadedSHIFT = true;
            this.chartEnergyLoadedDimpact = true;
            this.chartCo2LoadedDimpact = true;
            this.chartEnergySavingLoaded = true;
            this.chartEnergySavingLoadedIEA = true;
            this.chartEnergySavingLoadedSHIFT = true;
            this.chartEnergySavingLoadedDimpact = true;
            this.chartWaterLoaded = true;
            this.chartWaterLoadedIEA = true;
            this.chartWaterLoadedSHIFT = true;
            this.chartWaterLoadedDimpact = true;
        }
    },
    loadMB_Sec_Connected() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestMBConnected(options, values);
            /*self.chartMBLoaded = false;
            self.chartViewingTimeLoaded = false;
            self.chartBitrateLoaded = false;
            self.chartOffloadLoaded = false;*/
            self.loadRequestMBConnected(data).then(() => {
                self.totalMB_peer_connected = self.MB_peer_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server_connected = self.MB_server_connected.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_connected = self.totalMB_peer_connected + self.totalMB_server_connected;
                /*self.totalsec_peer = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime = self.totalsec_peer + self.totalsec_server;*/


                /*self.chartMBdata.datasets[0].data = self.MB_server;
                self.chartMBdata.datasets[1].data = self.MB_peer;
                self.chartMBLoaded = true;

                self.chartViewingTimedata.datasets[0].data = self.sec_server;
                self.chartViewingTimedata.datasets[1].data = self.sec_peer;
                self.chartViewingTimeLoaded = true;

                self.chartBitratedata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartBitratedata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer[i].y + self.MB_server[i].y) / (self.sec_peer[i].y + self.sec_server[i].y)))
                    })
                }*/

                self.chartOffloaddata.datasets[1].data = [];
                for (let i = 0; i < self.MB_server_connected.length; i++) {
                    self.chartOffloaddata.datasets[1].data.push({
                        x: new Date(self.MB_server_connected[i].x.getTime()),
                        y: (this.MB_peer_connected[i].y + this.MB_server_connected[i].y === 0) ? 0 : Math.round((self.MB_peer_connected[i].y / (self.MB_server_connected[i].y + self.MB_peer_connected[i].y) ) * 100 * 10) / 10
                    })
                }

                /*self.totalMaxQuality = self.bestQuality.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities = self.otherQualities.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self.bestQuality.length; i++) {
                    self.chartPercentQualitydata.datasets[0].data.push({
                        x: new Date(self.bestQuality[i].x),
                        y: (self.bestQuality[i].y + self.otherQualities[i].y === 0) ? 0 : Math.round(self.bestQuality[i].y / (self.bestQuality[i].y + self.otherQualities[i].y) * 100 * 100) / 100
                    })
                }

                self.chartBitrateLoaded = true;
                self.chartPercentQualityLoaded = true;
                self.fillRebufChart();
                self.fillMeanViewingTime();
                self.fillEnergy();*/
                self.chartOffloadLoaded = true;

                done();
            }).catch(err => {
                reject(err);
            });
        })
    },        
    loadMB_Sec() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'MB_peer', type: 'sum'}, {name: 'MB_server', type: 'sum'}, {name: 'sec_peer', type: 'sum'}, {name: 'sec_server', type: 'sum'}, {name: 'bestQuality', type: 'sum'}, {name: 'otherQualities', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.chartMBLoaded = false;
            self.chartViewingTimeLoaded = false;
            self.chartBitrateLoaded = false;
            self.chartOffloadLoaded = false;
            self.loadRequest(data, values).then(() => {
                self.totalMB_peer = self.MB_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB_server = self.MB_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalMB = self.totalMB_peer + self.totalMB_server;

                self.totalsec_peer = self.sec_peer.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalsec_server = self.sec_server.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalViewingTime = self.totalsec_peer + self.totalsec_server;


                self.chartMBdata.datasets[0].data = self.MB_server;
                self.chartMBdata.datasets[1].data = self.MB_peer;
                self.chartMBLoaded = true;

                self.chartViewingTimedata.datasets[0].data = self.sec_server;
                self.chartViewingTimedata.datasets[1].data = self.sec_peer;
                self.chartViewingTimeLoaded = true;

                self.chartBitratedata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartBitratedata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.sec_peer[i].y + this.sec_server[i].y === 0) ? 0 : Math.round(8 * ((self.MB_peer[i].y + self.MB_server[i].y) / (self.sec_peer[i].y + self.sec_server[i].y)))
                    })
                }

                self.chartOffloaddata.datasets[0].data = [];
                for (let i = 0; i < self.MB_server.length; i++) {
                    self.chartOffloaddata.datasets[0].data.push({
                        x: new Date(self.MB_server[i].x.getTime()),
                        y: (this.MB_peer[i].y + this.MB_server[i].y === 0) ? 0 : Math.round((self.MB_peer[i].y / (self.MB_server[i].y + self.MB_peer[i].y) ) * 100 * 10) / 10
                    })
                }

                self.totalMaxQuality = self.bestQuality.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalOtherQualities = self.otherQualities.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                for (let i = 0; i < self.bestQuality.length; i++) {
                    self.chartPercentQualitydata.datasets[0].data.push({
                        x: new Date(self.bestQuality[i].x),
                        y: (self.bestQuality[i].y + self.otherQualities[i].y === 0) ? 0 : Math.round(self.bestQuality[i].y / (self.bestQuality[i].y + self.otherQualities[i].y) * 100 * 100) / 100
                    })
                }

                self.chartBitrateLoaded = true;
                //self.chartOffloadLoaded = true;
                self.chartPercentQualityLoaded = true;
                self.fillRebufChart();
                self.fillMeanViewingTime();
                self.fillEnergy();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergy() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergy(options);
            self.loadRequestEnergy(data).then(() => {
                self.fillEnergyData();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergyConnected() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergyConnected(options);
            self.loadRequestEnergyConnected(data).then(() => {
                //self.fillEnergy();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergyData() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergyData(options);
            self.loadRequestEnergyData(data).then(() => {
                self.fillEnergyData();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadEnergyDataConnected() {
        let self = this;
        return new Promise((done, reject) => {
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequestEnergyDataConnected(options);
            self.loadRequestEnergyDataConnected(data).then(() => {
                self.fillEnergyData();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRebuf() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'sec_rebuf', type: 'sum'}, {name: 'glitches', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.loadRequest(data, values).then(() => {
                self.totalRebufMin = self.sec_rebuf.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.fillRebufChart();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadClientUuid() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'client_uuid.keyword', type: 'cardinality'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.loadRequest(data, values).then(() => {
                // Moved to new client uuid
                /*self.totalViews = self.client_uuid.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.chartViewsdata.datasets[0].data = self.client_uuid;
                self.chartViewsLoaded = true;
                self.fillMeanViewingTime();*/
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadNewClientUuid() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'new_client_number', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequest(options, values);
            self.chartViewsLoaded = false;
            self.loadRequest(data, values).then(() => {
                /*self.totalViews = self.new_client_uuid.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.chartViewsdata.datasets[0].data = self.new_client_uuid;*/
                self.totalViews = self.new_client_number.reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.chartViewsdata.datasets[0].data = self.new_client_number;
                self.chartViewsLoaded = true;
                self.fillMeanViewingTime();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRepresentedClients() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequestConcurrent(options, values);
            self.chartConcurrentViewsLoaded = false;
            self.loadRequestConcurrent(data, values).then(() => {
                /*if (self.represented_client.length > 2) {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 2].y;
                } else {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 1].y;
                }*/
                if (self.represented_client.length > 0) {
                    let listClients = self.represented_client.map(x => x.y);
                    self.concurrentViews = Math.max(...listClients);
                } else {
                    self.concurrentViews = 0;
                }

                self.chartConcurrentViewsdata.datasets[0].data = self.represented_client;
                
                //self.chartConcurrentViewsLoaded = true;
                //self.fillMeanViewingTime();
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadClientsConnected() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter};
            let data = self.templateRequestConnected(options, values);
            self.chartConcurrentViewsLoaded = false;
            self.loadRequestConnectedConcurrent(data, values).then(() => {
                if (self.represented_connected_client.length > 0) {
                    let listClients = self.represented_connected_client.map(x => x.y);
                    self.connectedViews = Math.max(...listClients);
                } else {
                    self.connectedViews = 0;
                }

                self.chartConcurrentViewsdata.datasets[1].data = self.represented_connected_client;
                
                self.chartConcurrentViewsLoaded = true;
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    /*loadRepresentedClients() {
        let self = this;
        return new Promise((done, reject) => {
            let values = [{name: 'represented_client', type: 'sum'}];
            let options = {dateBegin: new Date(self.range.end.getFullYear(),  self.range.end.getMonth(), self.range.end.getDate() - 1, self.range.end.getHours(), 0, 0), dateEnd: self.range.end, interval: '10s', filter: self.filter}
            let data = self.templateRequest(options, values);
            self.chartConcurrentViewsLoaded = false;
            self.loadRequest(data, values).then(() => {
                if (self.represented_client.length > 2) {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 2].y;
                } else {
                    self.concurrentViews = self.represented_client[self.represented_client.length - 1].y;
                }

                self.chartConcurrentViewsdata.datasets[0].data = [];
                let decoup = 800;
                let cut = Math.ceil(self.represented_client.length / decoup);
                for (let i = 0; i < decoup; i++) {
                    let subData;
                    if (i === decoup - 1) {
                        subData = self.represented_client.slice(i * cut);
                    } else {
                        subData = self.represented_client.slice(i * cut, i * cut + cut);
                    }
                    if (subData.length > 0) {
                        let sum = subData.reduce((a,b) => {
                            return {y: a.y + b.y}
                        }, {y: 0})
                        let lengthSubData = subData.filter(x => x.y !== 0);
                        let thisLength = (lengthSubData.length === 0) ? 1 : lengthSubData.length;
                        let average = Math.round(sum.y/thisLength);

                        self.chartConcurrentViewsdata.datasets[0].data.push({
                            x: new Date(subData[0].x.getTime()),
                            y: average
                        })
                    }
                }
                self.chartConcurrentViewsLoaded = true;
                done();
            }).catch(err => {
                reject(err);
            });
        })
    },*/
    loadQualities() {
        let self = this;
        return new Promise((done, reject) => {
//            let values = [{name: 'qualities.SD', type: 'sum'}, {name: 'qualities.HD', type: 'sum'}, {name: 'qualities.FullHD', type: 'sum'}, {name: 'qualities.2K', type: 'sum'}, {name: 'qualities.4K', type: 'sum'}, {name: 'qualities.8K', type: 'sum'}];
            let values = [{name: 'qualities.SD', type: 'sum'}, {name: 'qualities.HD', type: 'sum'}, {name: 'qualities.FullHD', type: 'sum'}, {name: 'qualities.2K', type: 'sum'}, {name: 'qualities.4K', type: 'sum'}];
            let options = {dateBegin: self.range.start, dateEnd: self.range.end, interval: self.interval, filter: self.filter}
            let data = self.templateRequest(options, values);
            self.chartQualitiesLoaded = false;
            self.chartPercentQualityLoaded = false;
            self.loadRequest(data, values).then(() => {
                self.totalSD = self['qualities.SD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalHD = self['qualities.HD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.totalFullHD = self['qualities.FullHD'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.total2K = self['qualities.2K'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
                self.total4K = self['qualities.4K'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;
//                self.total8K = self['qualities.8K'].reduce((a,b)=> {return {y: Math.round(a.y + b.y)}}).y;

                self.chartQualitiesdata.datasets[0].data = self['qualities.SD'];
                self.chartQualitiesdata.datasets[1].data = self['qualities.HD'];
                self.chartQualitiesdata.datasets[2].data = self['qualities.FullHD'];
                self.chartQualitiesdata.datasets[3].data = self['qualities.2K'];
                self.chartQualitiesdata.datasets[4].data = self['qualities.4K'];
//                self.chartQualitiesdata.datasets[5].data = self['qualities.8K'];

                self.chartQualitiesLoaded = true;

                done();
            }).catch(err => {
                reject(err);
            });
        })
    },
    loadRequest(data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    for(let j = 0; j < valuesToFill.length; j++) {
                        let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
                        self[myValue] = [];
                    }
                    for(let i = 0; i < buckets.length; i++) {
                        for(let j = 0; j < valuesToFill.length; j++) {
                            let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
                            self[myValue].push({
                                x: new Date(buckets[i].key),
                                y: buckets[i][myValue].value
                            });
                        }
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    loadRequestMBConnected(data) {
        let self = this;
        return new Promise ((done, reject) => {
            let valuesToFill = [
                {name: 'MB_peer', fillingName:'MB_peer_connected' ,type: 'sum'}, 
                {name: 'MB_server', fillingName:'MB_server_connected', type: 'sum'},
                {name: 'sec_peer', fillingName:'sec_peer_connected', type: 'sum'},
                {name: 'sec_server', fillingName:'sec_server_connected', type: 'sum'}
            ];
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;

                    for(let j = 0; j < valuesToFill.length; j++) {
                        let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].fillingName.split('.')[0] : valuesToFill[j].fillingName;
                        self[myValue] = [];
                    }


                    for(let i = 0; i < buckets.length; i++) {
                        for(let j = 0; j < valuesToFill.length; j++) {
                            let myValue = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].fillingName.split('.')[0] : valuesToFill[j].fillingName;
                            let myValueName = (valuesToFill[j].name.indexOf('keyword') > -1) ? valuesToFill[j].name.split('.')[0] : valuesToFill[j].name;
        
                            self[myValue].push({
                                x: new Date(buckets[i].key),
                                y: buckets[i][myValueName].value
                            });
                        }
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    templateRequest({dateBegin, dateEnd, interval, filter}, values) {
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBegin.getTime().toString(),
                                    "lte": dateEnd.getTime().toString(),
                                    "format":"epoch_millis"
                                }
                            }
                        }
                        
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBegin.getTime().toString(),
                            "max": dateEnd.getTime().toString()
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {

                    }
                }
            }
        }
        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "match":{
                                "video_id": {
                                    "query": filter
                                }
                            }
                        })
        } 

        for (var i = 0; i < values.length; i++) {
            let name = (values[i].name.indexOf('keyword') > -1) ? values[i].name.split('.')[0] : values[i].name;
            let value = values[i].name;
            let type = values[i].type
            data.aggs.histogram.aggs[name] = {}
            data.aggs.histogram.aggs[name][type] = {
                "field": value,
                "missing":0
            }
            if (type === "cardinality") {
                data.aggs.histogram.aggs[name][type].precision_threshold = 40000
            }
        }

        return data;
    },
    templateRequestMBConnected({dateBegin, dateEnd, interval, filter}, values) {
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBegin.getTime().toString(),
                                    "lte": dateEnd.getTime().toString(),
                                    "format":"epoch_millis"
                                }
                            }
                        }   
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBegin.getTime().toString(),
                            "max": dateEnd.getTime().toString()
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {

                    }
                }
            }
        }
        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "match":{
                                "video_id": {
                                    "query": filter
                                }
                            }
                        })
        } 

        for (var i = 0; i < values.length; i++) {
            let name = (values[i].name.indexOf('keyword') > -1) ? values[i].name.split('.')[0] : values[i].name;
            let value = values[i].name;
            let type = values[i].type
            data.aggs.histogram.aggs[name] = {}
            data.aggs.histogram.aggs[name][type] = {
                "field": 'connected.' + value,
                "missing":0
            }
            if (type === "cardinality") {
                data.aggs.histogram.aggs[name][type].precision_threshold = 40000
            }
        }

        return data;
    },    
    templateRequestEnergy({dateBegin, dateEnd, interval, filter}) {
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBegin.getTime().toString(),
                                    "lte": dateEnd.getTime().toString(),
                                    "format":"epoch_millis"
                                }
                            }
                        }
                        /*{
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter
                            }
                        }*/
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBegin.getTime().toString(),
                            "max": dateEnd.getTime().toString()
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {
                        "timeLQ":{
                            "sum":{
                                "field":"timeLQ",
                                "missing":0
                            }
                        },
                        "timeHQ":{
                            "sum":{
                                "field":"timeHQ",
                                "missing":0
                            }
                        },
                        "MB_peer_ip":{
                            "sum":{
                                "field":"MB_peer_ip",
                                "missing":0
                            }
                        },
                        "MB_peer_city":{
                            "sum":{
                                "field":"MB_peer_city",
                                "missing":0
                            }
                        },
                        "MB_peer_region":{
                            "sum":{
                                "field":"MB_peer_region",
                                "missing":0
                            }
                        },
                        "MB_peer_country":{
                            "sum":{
                                "field":"MB_peer_country",
                                "missing":0
                            }
                        },
                        "sec_peer_wifi":{
                            "sum":{
                                "field":"wifi.sec_peer",
                                "missing":0
                            }
                        },
                        "sec_server_wifi":{
                            "sum":{
                                "field":"wifi.sec_server",
                                "missing":0
                            }
                        },
                        "sec_peer_cellular":{
                            "sum":{
                                "field":"cellular.sec_peer",
                                "missing":0
                            }
                        },
                        "sec_server_cellular":{
                            "sum":{
                                "field":"cellular.sec_server",
                                "missing":0
                            }
                        },
                        "MB_peer_wifi":{
                            "sum":{
                                "field":"wifi.MB_peer",
                                "missing":0
                            }
                        },
                        "MB_server_wifi":{
                            "sum":{
                                "field":"wifi.MB_server",
                                "missing":0
                            }
                        },
                        "MB_peer_cellular":{
                            "sum":{
                                "field":"cellular.MB_peer",
                                "missing":0
                            }
                        },
                        "MB_server_cellular":{
                            "sum":{
                                "field":"cellular.MB_server",
                                "missing":0
                            }
                        },
                        "sec_peer_phone":{
                            "sum":{
                                "field":"phone.sec_peer",
                                "missing":0
                            }
                        },
                        "sec_server_phone":{
                            "sum":{
                                "field":"phone.sec_server",
                                "missing":0
                            }
                        },
                        "MB_peer_phone":{
                            "sum":{
                                "field":"phone.MB_peer",
                                "missing":0
                            }
                        },
                        "MB_server_phone":{
                            "sum":{
                                "field":"phone.MB_server",
                                "missing":0
                            }
                        },
                        "sec_peer_tablet":{
                            "sum":{
                                "field":"tablet.sec_peer",
                                "missing":0
                            }
                        },
                        "sec_server_tablet":{
                            "sum":{
                                "field":"tablet.sec_server",
                                "missing":0
                            }
                        },
                        "MB_peer_tablet":{
                            "sum":{
                                "field":"tablet.MB_peer",
                                "missing":0
                            }
                        },
                        "MB_server_tablet":{
                            "sum":{
                                "field":"tablet.MB_server",
                                "missing":0
                            }
                        },
                        "sec_peer_desktop":{
                            "sum":{
                                "field":"desktop.sec_peer",
                                "missing":0
                            }
                        },
                        "sec_server_desktop":{
                            "sum":{
                                "field":"desktop.sec_server",
                                "missing":0
                            }
                        },
                        "MB_peer_desktop":{
                            "sum":{
                                "field":"desktop.MB_peer",
                                "missing":0
                            }
                        },
                        "MB_server_desktop":{
                            "sum":{
                                "field":"desktop.MB_server",
                                "missing":0
                            }
                        },
                        //CONNECTED
                        "connected_timeLQ":{
                            "sum":{
                                "field":"connected.timeLQ",
                                "missing":0
                            }
                        },
                        "connected_timeHQ":{
                            "sum":{
                                "field":"connected.timeHQ",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_ip":{
                            "sum":{
                                "field":"connected.MB_peer_ip",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_city":{
                            "sum":{
                                "field":"connected.MB_peer_city",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_region":{
                            "sum":{
                                "field":"connected.MB_peer_region",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_country":{
                            "sum":{
                                "field":"connected.MB_peer_country",
                                "missing":0
                            }
                        },
                        "connected_sec_peer_wifi":{
                            "sum":{
                                "field":"connected.wifi.sec_peer",
                                "missing":0
                            }
                        },
                        "connected_sec_server_wifi":{
                            "sum":{
                                "field":"connected.wifi.sec_server",
                                "missing":0
                            }
                        },
                        "connected_sec_peer_cellular":{
                            "sum":{
                                "field":"connected.cellular.sec_peer",
                                "missing":0
                            }
                        },
                        "connected_sec_server_cellular":{
                            "sum":{
                                "field":"connected.cellular.sec_server",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_wifi":{
                            "sum":{
                                "field":"connected.wifi.MB_peer",
                                "missing":0
                            }
                        },
                        "connected_MB_server_wifi":{
                            "sum":{
                                "field":"connected.wifi.MB_server",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_cellular":{
                            "sum":{
                                "field":"connected.cellular.MB_peer",
                                "missing":0
                            }
                        },
                        "connected_MB_server_cellular":{
                            "sum":{
                                "field":"connected.cellular.MB_server",
                                "missing":0
                            }
                        },
                        "connected_sec_peer_phone":{
                            "sum":{
                                "field":"connected.phone.sec_peer",
                                "missing":0
                            }
                        },
                        "connected_sec_server_phone":{
                            "sum":{
                                "field":"connected.phone.sec_server",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_phone":{
                            "sum":{
                                "field":"connected.phone.MB_peer",
                                "missing":0
                            }
                        },
                        "connected_MB_server_phone":{
                            "sum":{
                                "field":"connected.phone.MB_server",
                                "missing":0
                            }
                        },
                        "connected_sec_peer_tablet":{
                            "sum":{
                                "field":"connected.tablet.sec_peer",
                                "missing":0
                            }
                        },
                        "connected_sec_server_tablet":{
                            "sum":{
                                "field":"connected.tablet.sec_server",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_tablet":{
                            "sum":{
                                "field":"connected.tablet.MB_peer",
                                "missing":0
                            }
                        },
                        "connected_MB_server_tablet":{
                            "sum":{
                                "field":"connected.tablet.MB_server",
                                "missing":0
                            }
                        },
                        "connected_sec_peer_desktop":{
                            "sum":{
                                "field":"connected.desktop.sec_peer",
                                "missing":0
                            }
                        },
                        "connected_sec_server_desktop":{
                            "sum":{
                                "field":"connected.desktop.sec_server",
                                "missing":0
                            }
                        },
                        "connected_MB_peer_desktop":{
                            "sum":{
                                "field":"connected.desktop.MB_peer",
                                "missing":0
                            }
                        },
                        "connected_MB_server_desktop":{
                            "sum":{
                                "field":"connected.desktop.MB_server",
                                "missing":0
                            }
                        },
                    }
                }
            }
        }
        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "match":{
                                "video_id": {
                                    "query": filter
                                }
                            }
                        })
        } 

        return data;
    },    
    templateRequestConcurrent({dateBegin, dateEnd, interval, filter}) {
        let intervalInSeconds = this.intervalOptions.find(x => x.value === interval).tenSeconds;
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBegin.getTime().toString(),
                                    "lte": dateEnd.getTime().toString(),
                                    "format":"epoch_millis"
                                }
                            }
                        }
                        /*{
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter.split('-').shift()
                            }
                        }*/
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBegin.getTime().toString(),
                            "max": dateEnd.getTime().toString()
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {
                        "1":{
                            "sum":{
                                "field":"represented_client",
                                "missing": 0
                            }
                        },
                        "3":{
                            "bucket_script":{
                                "buckets_path":{
                                    "var1":"1"
                                },
                                "script":"params.var1 / " + intervalInSeconds
                            }
                        }
                    }
                }
            }
        }
        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "match":{
                                "video_id": {
                                    "query": filter
                                }
                            }
                        })
        } 

        return data;
    },    
    templateRequestConnected({dateBegin, dateEnd, interval, filter}) {
        let intervalInSeconds = this.intervalOptions.find(x => x.value === interval).tenSeconds;
        let data = {
            "query":{
                "bool":{
                    "filter":[
                        {
                            "range":{
                                "timestamp":{
                                    "gte": dateBegin.getTime().toString(),
                                    "lte": dateEnd.getTime().toString(),
                                    "format":"epoch_millis"
                                }
                            }
                        }

                        /*{
                            "query_string":{
                                "analyze_wildcard": true,
                                "query": filter.split('-').shift()
                            }
                        }*/
                    ]
                }
            },
            "size": 0,
            "aggs":{
                "histogram":{
                    "date_histogram":{
                        "interval": interval,
                        "field":"timestamp",
                        "min_doc_count":0,
                        "extended_bounds":{
                            "min": dateBegin.getTime().toString(),
                            "max": dateEnd.getTime().toString()
                        },
                        "format":"epoch_millis"
                    },
                    "aggs": {
                        "1":{
                            "sum":{
                                "field":"connected.represented_client",
                                "missing": 0
                            }
                        },
                        "3":{
                            "bucket_script":{
                                "buckets_path":{
                                    "var1":"1"
                                },
                                "script":"params.var1 / " + intervalInSeconds
                            }
                        }
                    }
                }
            }
        }
        if (["*", ""].indexOf(filter) === -1) {
            data.query.bool.filter.push({
                            "match":{
                                "video_id": {
                                    "query": filter
                                }
                            }
                        })
        } 

        return data;
    },
    loadRequestConcurrent(data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    self.represented_client = [];
                    for(let i = 0; i < buckets.length; i++) {
                        if (buckets[i]["1"].value === 0 && !buckets[i]["3"]) {
                            buckets[i]["3"] = {value: 0};
                        }
                        if (buckets[i]["1"].value > 0 && buckets[i]["3"] === 0) {
                            buckets[i]["3"] = {value: 1};
                        }
                        self.represented_client.push({
                            x: new Date(buckets[i].key),
                            y: Math.ceil(buckets[i]["3"].value)
                        });
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },    
    loadRequestConnectedConcurrent(data, valuesToFill) {
        let self = this;
        return new Promise ((done, reject) => {
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    self.represented_connected_client = [];
                    for(let i = 0; i < buckets.length; i++) {
                        if (buckets[i]["1"].value === 0 && !buckets[i]["3"]) {
                            buckets[i]["3"] = {value: 0};
                        }
                        if (buckets[i]["1"].value > 0 && buckets[i]["3"] === 0) {
                            buckets[i]["3"] = {value: 1};
                        }
                        self.represented_connected_client.push({
                            x: new Date(buckets[i].key),
                            y: Math.ceil(buckets[i]["3"].value)
                        });
                    }
                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    loadRequestEnergy(data) {
        let self = this;
        return new Promise ((done, reject) => {
            analyticsService.getAnalyticsFromServer(self.key, data, self.$auth.token())
                .then((response) => {
                    let buckets = response.aggregations.histogram.buckets;
                    
                    self.networkWifi = [];
                    self.networkCellular = [];
                    self.devicePhone = [];
                    self.deviceTablet = [];
                    self.deviceComputer = [];
                    self.timeLQ = [];
                    self.timeHQ = [];

                    self.networkWifiConnected = [];
                    self.networkCellularConnected = [];
                    self.devicePhoneConnected = [];
                    self.deviceTabletConnected = [];
                    self.deviceComputerConnected = [];
                    self.timeLQConnected = [];
                    self.timeHQConnected = [];

                    self.networkWifiData = [];
                    self.networkCellularData = [];
                    self.devicePhoneData = [];
                    self.deviceTabletData = [];
                    self.deviceComputerData = [];
                    self.MB_peer_city = [];
                    self.MB_peer_region = [];
                    self.MB_peer_country = [];
                    self.MB_peer_ip = [];

                    self.networkWifiDataConnected = [];
                    self.networkCellularDataConnected = [];
                    self.devicePhoneDataConnected = [];
                    self.deviceTabletDataConnected = [];
                    self.deviceComputerDataConnected = [];
                    self.MB_peer_cityConnected = [];
                    self.MB_peer_regionConnected = [];
                    self.MB_peer_countryConnected = [];
                    self.MB_peer_ipConnected = [];

                    for(let i = 0; i < buckets.length; i++) {
                        let timestamp = new Date(buckets[i].key)
                        self.timeLQ.push({
                            x: timestamp,
                            y: buckets[i].timeLQ.value
                        })

                        self.timeHQ.push({
                            x: timestamp,
                            y: buckets[i].timeHQ.value
                        })

                        //wifi 
                        self.networkWifi.push({
                            x: timestamp,
                            y: buckets[i].sec_server_wifi.value + buckets[i].sec_peer_wifi.value
                        })

                        //cellular
                        self.networkCellular.push({
                            x: timestamp,
                            y: buckets[i].sec_server_cellular.value + buckets[i].sec_peer_cellular.value
                        })

                        //phone 
                        self.devicePhone.push({
                            x: timestamp,
                            y: buckets[i].sec_server_phone.value  + buckets[i].sec_peer_phone.value 
                        })

                        //tablet 
                        self.deviceTablet.push({
                            x: timestamp,
                            y: buckets[i].sec_server_tablet.value  + buckets[i].sec_peer_tablet.value 
                        })

                        //computer 
                        self.deviceComputer.push({
                            x: timestamp,
                            y: buckets[i].sec_server_desktop.value  + buckets[i].sec_peer_desktop.value 
                        })

                        self.timeLQConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_timeLQ.value
                        })

                        self.timeHQConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_timeHQ.value
                        })

                        //wifi 
                        self.networkWifiConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_wifi.value + buckets[i].connected_sec_peer_wifi.value
                        })

                        //cellular
                        self.networkCellularConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_cellular.value + buckets[i].connected_sec_peer_cellular.value
                        })

                        //phone 
                        self.devicePhoneConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_phone.value + buckets[i].connected_sec_peer_phone.value
                        })

                        //tablet 
                        self.deviceTabletConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_tablet.value + buckets[i].connected_sec_peer_tablet.value
                        })

                        //computer 
                        self.deviceComputerConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_sec_server_desktop.value + buckets[i].connected_sec_peer_desktop.value
                        })

                        //wifi 
                        self.networkWifiData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_wifi.value + buckets[i].MB_peer_wifi.value
                        })

                        //cellular
                        self.networkCellularData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_cellular.value + buckets[i].MB_peer_cellular.value
                        })

                        //phone 
                        self.devicePhoneData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_phone.value + buckets[i].MB_peer_phone.value
                        })
                        //tablet 
                        self.deviceTabletData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_tablet.value + buckets[i].MB_peer_tablet.value
                        })

                        //computer 
                        self.deviceComputerData.push({
                            x: timestamp,
                            y: buckets[i].MB_server_desktop.value + buckets[i].MB_peer_desktop.value

                        })
                    
                        //City
                        self.MB_peer_city.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_city.value
                        })

                        self.MB_peer_region.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_region.value
                        })

                        self.MB_peer_country.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_country.value
                        })

                        self.MB_peer_ip.push({
                            x: timestamp,
                            y: buckets[i].MB_peer_ip.value
                        })

                        self.networkWifiDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_wifi.value + buckets[i].connected_MB_peer_wifi.value
                        })

                        //cellular
                        self.networkCellularDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_cellular.value + buckets[i].connected_MB_peer_cellular.value
                        })

                        //phone 
                        self.devicePhoneDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_phone.value + buckets[i].connected_MB_peer_phone.value
                        })
                        //tablet 
                        self.deviceTabletDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_tablet.value + buckets[i].connected_MB_peer_tablet.value
                        })

                        //computer 
                        self.deviceComputerDataConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_server_desktop.value + buckets[i].connected_MB_peer_desktop.value

                        })
                    
                        //City
                        self.MB_peer_cityConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_city.value
                        })

                        self.MB_peer_regionConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_region.value
                        })

                        self.MB_peer_countryConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_country.value
                        })

                        self.MB_peer_ipConnected.push({
                            x: timestamp,
                            y: buckets[i].connected_MB_peer_ip.value
                        })

                    }
                    self.chartViewingTimeDevicedata.datasets[2].data = self.devicePhone;
                    self.chartViewingTimeDevicedata.datasets[1].data = self.deviceTablet;
                    self.chartViewingTimeDevicedata.datasets[0].data = self.deviceComputer;
                    
                    self.totalViewingTimeMobile = self.devicePhone.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.totalViewingTimeTablet = self.deviceTablet.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.totalViewingTimeDesktop = self.deviceComputer.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.chartViewingTimeDeviceLoaded = true;

                    self.chartViewingTimeNetworkdata.datasets[0].data = self.networkWifi;
                    self.chartViewingTimeNetworkdata.datasets[1].data = self.networkCellular;
                    self.totalViewingTimeWifi = self.networkWifi.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.totalViewingTimeCellular = self.networkCellular.reduce((a,b) => {return {y:a.y + b.y}}, {y: 0}).y;
                    self.chartViewingTimeNetworkLoaded = true;

                    done();
                }).catch((err) => {
                    reject(err);
                });
        })
    },
    startTimeoutSearch() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      if (this.oldSearch !== this.filter) {
        this.isGetInProgress = true;
        this.timeoutSearch = setTimeout(this.loadData, this.timeoutSearchDuration * 1000);
        this.isLoading = true;
      } else {
        this.isGetInProgress = false;
      }
      
    },
    showModal(modalRef) {
      this.$refs[modalRef].show();
    },
    hideModal(modalRef) {
      this.$refs[modalRef].hide();
    },
    prepareModalSelectionVideos()
    {
      this.selectedVideosTmp = [...this.selectedVideos]
    },
    getVideos() {
      var filter = {
        client: this.clientView, 
      }
      if (this.searchBar !== "") {
        filter.title = {"$regex": "(?i)^.*" + this.searchBar + ".*"}
      }
      videoService.getVideosPageForClient(this.$auth.token(), 
      {
        filter: filter,
        sort: {
          createdAt: -1
        }, 
        page: this.videoPage, 
        pagesize: this.videoPageSize
      }).then((data) => {
            this.totalPages = Math.ceil(data._size / this.videoPageSize);
            this.videos = data._embedded;
        }).catch((err) => {
            this.showModal('errorGet');
        })
    },
    cleanVideos() {
      this.videos = [];
      this.videoPage = 1;
      this.searchBar = "";
    },
    selectVideo(video)
    {
        let fieldToUse = (video && video.authorizationKey && video.authorizationKey.indexOf('cam') > -1) ? video.authorizationKey : video.uuid
        if(!this.selectedVideosTmp.includes(fieldToUse))
        {
            this.selectedVideosTmp.push(fieldToUse)
        } else
        {
            let idx = this.selectedVideosTmp.indexOf(fieldToUse)
            this.selectedVideosTmp.splice(idx,1)
        }
    },
    selectVideoPlugin(video)
    {
        if(!this.selectedVideosTmp.includes(video.videoID))
        {
            this.selectedVideosTmp.push(video.videoID)
        } else
        {
            let idx = this.selectedVideosTmp.indexOf(video.videoID)
            this.selectedVideosTmp.splice(idx,1)
        }
    },
    loadSelectedVideos()
    {
        //filter= video1.uuid.split('-').shift() + ' OR ' + video2.uuid.split('-').shift()
        this.selectedVideos = [...this.selectedVideosTmp]
        if(this.selectedVideos.length === 0)
        {
            this.filter = "*"
        }
        else{
            this.filter = ""
            this.selectedVideos.forEach(uuid => {
                if(this.filter != "")
                {
                    this.filter = this.filter + " "
                }
                this.filter+=uuid
            });
            }

        this.startTimeoutSearch()


    },
    imgUrlAlt(event) {
      event.target.src = `/thumbnail.jpg`
    },
    getPluginVideosList()
    {
        var filter ={};
        if (this.searchBar !== "") {
            filter.videoID = {"$regex": "(?i)^.*" + this.searchBar + ".*"}
        }

        videoService.getVideoListPlugin(this.$auth.token(),
            {
                filter: filter,
                sort: {
                    createdDate: -1
                }, 
                page: this.videoPage, 
                pagesize: this.videoPageSize
            })
            .then(response=>{
            this.videosPlugin = response._embedded;
            for (let video in this.videosPlugin) 
            {
                this.videosPlugin[video]._created = moment(this.videosPlugin[video].createdDate).format("DD/MM/YY @HH:mm");
            }
        }).catch(err=>{
            console.log(err)
        })
    },
    updateVideoPluginList()
    {
        videoService.refreshVideoPlugin(this.$auth.token())
        .then(()=>{
            this.getPluginVideosList();
        })
        .catch(err=>{
            console.log(err)
        })
    },
    energyMethodChanged(method){
       /* this.chartEnergydata.datasets[0].data = [];
        this.chartEnergydata.datasets[1].data = [];energyNormal
        this.chartCo2data.datasets[0].data = [];
        this.chartCo2data.datasets[1].data = [];
        this.chartEnergySavingdata.datasets[0].data = [];
        this.chartEnergySavingdata.datasets[1].data = [];

        this.chartEnergyLoaded = false;
        this.chartCo2Loaded = false;
        this.chartEnergySavingLoaded = false;


        if(method === "quanteec")
        {
            console.log("quanteec")

            this.chartEnergydata.datasets[0].data = this.energyNormal;
            this.chartEnergydata.datasets[1].data = this.energyQuanteec;

            this.chartCo2data.datasets[0].data = this.co2Normal;
            this.chartCo2data.datasets[1].data = this.co2Quanteec;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteec;
            this.chartEnergySavingdata.datasets[1].data = this.energySavingQuanteecConnected;
        } else if (method === "iea") {

            console.log("iea")
            this.chartEnergydata.datasets[0].data = this.energyNormalIEA;
            this.chartEnergydata.datasets[1].data = this.energyQuanteecIEA;

            this.chartCo2data.datasets[0].data = this.co2NormalIEA;
            this.chartCo2data.datasets[1].data = this.co2QuanteecIEA;

            this.chartEnergySavingdata.datasets[0].data = this.energySavingQuanteecIEA;
            this.chartEnergySavingdata.datasets[1].data = this.energySavingQuanteecConnectedIEA;
        }
        this.chartEnergyLoaded = true;
        this.chartCo2Loaded = true;
        this.chartEnergySavingLoaded = true;

        //EventBus.$emit("energyMethodChanged")
*/

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.centered {
    text-align: center;
}

.rightered {
    text-align: right;
}

.scrollmenu {
  display: flex;
  justify-content: space-between;
  overflow: auto;
  white-space: nowrap;
}
@media print {
    .noprint {
        display: none;
    }
    .printefficiency {
        margin-top: 200px;
    }
    .printenergy {
        margin-top: 400px;
    }
    .printviews {
        margin-top: 350px;
    }
}
.oldcard {
    box-shadow: rgba(#14BF98, 0.17) 2px 4px 14px, rgba(#14BF98, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: #fbfbfb !important;
    border-radius: 5px !important;
    border: 0.15rem solid #14BF98 !important;
//    background-color: rgba(109,236,142,0.517647); //green
    &:hover {
      box-shadow: rgba(#14BF98, 0.3) 4px 8px 20px, rgba(#14BF98, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.logoEn {
    max-width:23px;
    text-align: right;
}

.row1st {
    font-size:small; 
    background-color:#dfe5ec;
    margin: 3rem 0rem 0rem;
    padding-top: 2.3rem;
    padding-bottom: 2.3rem;
    align-items: center;
    justify-content: space-around;
    border-top: 1px solid #2a5d77;
    border-left: 1px solid #2a5d77;
    border-right: 1px solid #2a5d77;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.rowStats {
    justify-content: space-around;
    align-items: center;
    margin: 0rem;
    padding: 2rem 0rem;
    border-top: 1px solid #dfe5ec;
}

.rowDetailStats {
    align-items: center;
    margin-bottom: 1rem;
}


</style>
